let currencySymbols = {
  USD: "$",
  GBP: "£",
  EUR: "€",
  AUD: "A$",
};
let currentCurrency = "";
let mainSelectedCurrency = Object.keys(currencySymbols)[0];

const addPluralSuffix = (label, amount) => {
  if (label === "number") {
    if (amount > 1) return "numbers";
    return label;
  }
  return label;
};

const getElement = (el, wrap = document) => {
  if (el == null) return undefined;

  if (typeof el === "string") {
    try {
      return wrap.querySelector(el) || undefined;
    } catch ({ message }) {
      console.error(message);
      return undefined;
    }
  }
};

const getElements = (el, wrap = document) => {
  if (el == null) return undefined;

  if (typeof el === "string") {
    try {
      return wrap.querySelectorAll(el) || undefined;
    } catch ({ message }) {
      return undefined;
    }
  }
};
const style = (el, property) =>
  window.getComputedStyle(el).getPropertyValue(property);

const css = (el, css) => {
  Object.keys(css).forEach((prop) => {
    el.style[prop] = css[prop];
  });
};

const ready = (fn) => {
  if (document.readyState !== "loading") return fn();
  document.addEventListener("DOMContentLoaded", fn, false);
};

const stopAndPrevent = (e) => {
  e.cancelable !== false && e.preventDefault();
  e.stopPropagation();
};

const getCounter = (() => {
  let counter = 0;
  return () => {
    counter += 1;
    return counter;
  };
})();

const backdrop = {
  msToSec: (val) => `${val / 1000}s`,
  open: (transitionDuration = 200) => {
    document.documentElement.classList.add("backdrop");
    setTimeout(
      () => document.documentElement.classList.add("backdrop--opening"),
      0
    );
    setTimeout(backdrop._opened, transitionDuration);
    document.documentElement.style.setProperty(
      "--backdrop-transition-duration",
      backdrop.msToSec(transitionDuration)
    );
  },
  hide: (transitionDuration = 200) => {
    document.documentElement.classList.add("backdrop--hiding");
    setTimeout(backdrop._hidden, transitionDuration);
    document.documentElement.style.setProperty(
      "--backdrop-transition-duration",
      backdrop.msToSec(transitionDuration)
    );
  },
  _opened: () => {
    document.documentElement.classList.add("backdrop--opened");
    document.documentElement.classList.remove("backdrop--opening");
    document.documentElement.style.setProperty(
      "--backdrop-transition-duration",
      ""
    );
  },
  _hidden: () => {
    document.documentElement.classList.remove("backdrop--opened");
    document.documentElement.classList.remove("backdrop--hiding");
    document.documentElement.classList.remove("backdrop");
    document.documentElement.style.setProperty(
      "--backdrop-transition-duration",
      ""
    );
  },
};

class Swipe {
  constructor(element) {
    this.xDown = null;
    this.yDown = null;
    this.element = typeof element === "string" ? getElement(element) : element;

    this.element.addEventListener(
      "touchstart",
      function (evt) {
        this.xDown = evt.touches[0].clientX;
        this.yDown = evt.touches[0].clientY;
      }.bind(this),
      false
    );
  }
  onLeft(callback) {
    this.onLeft = callback;

    return this;
  }
  onRight(callback) {
    this.onRight = callback;

    return this;
  }
  onUp(callback) {
    this.onUp = callback;

    return this;
  }
  onDown(callback) {
    this.onDown = callback;

    return this;
  }
  handleTouchMove(evt) {
    if (!this.xDown || !this.yDown) {
      return;
    }

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    this.xDiff = this.xDown - xUp;
    this.yDiff = this.yDown - yUp;

    if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {
      // Most significant.
      if (this.xDiff > 0) {
        this.onLeft();
      } else {
        this.onRight();
      }
    } else {
      if (this.yDiff > 0) {
        this.onUp();
      } else {
        this.onDown();
      }
    }

    // Reset values.
    this.xDown = null;
    this.yDown = null;
  }

  run() {
    this.element.addEventListener(
      "touchmove",
      function (evt) {
        this.handleTouchMove(evt);
      }.bind(this),
      false
    );
  }
}

// TODO: add to WP

function removeTrailingZeros(number) {
  const formattedNumber = parseFloat(number).toFixed(2);
  return formattedNumber.replace(/\.00$/, "");
}

const numberWithCommas = (x) => {
  let n = x;
  let parts = (+n).toFixed(2).split(".");
  let num =
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    (+parts[1] ? "." + parts[1] : "");

  return num;
};

const numberWithCommasCalc = (x) => {
  return x.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
};

function ifItemExist(item) {
  if (item != null && item != undefined) {
    return true;
  } else {
    return false;
  }
}

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

function fits(x, y) {
  if (Number.isInteger(y / x)) {
    return true;
  }
  return false;
}

function updateTextView(_obj) {
  var num = getNumber(_obj.value);
  if (num == 0) {
    _obj.value = parseInt(_obj.getAttribute("min"));
  } else {
    _obj.value = num.toLocaleString();
  }
  return _obj.value;
}

function getNumber(_str) {
  var arr = _str.split("");
  var out = new Array();
  for (var cnt = 0; cnt < arr.length; cnt++) {
    if (isNaN(arr[cnt]) == false) {
      out.push(arr[cnt]);
    }
  }
  return Number(out.join(""));
}

function addMultipleListeners(element, events, handler, useCapture, args) {
  if (!ifItemExist(element)) {
    return;
  }

  if (!(events instanceof Array)) {
    throw (
      "addMultipleListeners: " +
      "please supply an array of eventstrings " +
      '(like ["click","mouseover"])'
    );
  }
  //create a wrapper to be able to use additional arguments
  var handlerFn = function (e) {
    handler.apply(this, args && args instanceof Array ? args : []);
  };
  for (var i = 0; i < events.length; i += 1) {
    element.addEventListener(events[i], handlerFn, useCapture);
  }
}

function sanitizeInput(input) {
  const sanitizedInput = input
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
  return sanitizedInput;
}

const globalListeners = {
  click: {},
  resize: {},
  scroll: {},
};
const addGlobalListeners = (type, cb, name) => {
  if (!name) {
    name = getCounter();
  }
  globalListeners[type][name] = cb;
};
// const removeGlobalListeners = (type, name) => { 
//   delete globalListeners[type][name]
// }
Object.keys(globalListeners).forEach((type) => {
  window.addEventListener(type, (e) => {
    if (Object.values(globalListeners[type]).length) {
      Object.values(globalListeners[type]).forEach((cb) => cb(e));
    }
  });
});
/* Global events end */

/* Header dropdown start */
class HeaderNavbar {
  constructor(el) {
    this.rootEl = el;
    this.innerGetElement = (selector) => getElement(selector, this.rootEl);
    this.innerGetElements = (selector) => getElements(selector, this.rootEl);

    this.navEl = this.innerGetElement(".navbar");
    this.toggleEls = Array.from(this.innerGetElements(".navbar-toggler"));
    this.collapseEl = this.innerGetElement(".collapse");
    this.headerDropdownEls = Array.from(this.innerGetElements(".dropdown"));

    this.mediaTransfor = "(min-width: 992px)";
    this.animationDuration = 200; // $transition-collapse from assets/scss/vendors/bootstrap/_variables.scss
    this.isDarkTheme = this.navEl.classList.contains("navbar-dark");
    this.isOpen = false;
    this.inProgress = false;
    this.lastOpenedLink = null;
    this.collapseOffsetHeight = null;
  }

  init() {
    this.headerFixing();
    this.initNavToggles();
    this.initDropdownEls();
    this.initGlobalListeners();
  }

  initGlobalListeners() {
    addGlobalListeners("scroll", this.headerFixing.bind(this));
    addGlobalListeners("click", this.clickOutside.bind(this));
    addGlobalListeners("resize", this.closeNavbar.bind(this));
  }

  headerFixing() {
    if (window.pageYOffset > 1) {
      this.rootEl.classList.add("header-scroll");
      this.navEl.classList.remove("navbar-dark");
    } else {
      this.rootEl.classList.remove("header-scroll");
      if (this.isDarkTheme) {
        if (!this.isOpen) {
          this.navEl.classList.add("navbar-dark");
        }
      } else {
        this.navEl.classList.remove("navbar-dark");
      }
    }
  }

  initNavToggles() {
    this.toggleEls.forEach((el) => {
      el.addEventListener("click", () => {
        if (this.isOpen) {
          this.closeNavbar();
        } else {
          this.openNavbar();
        }
      });
    });
  }

  initDropdownEls() {
    this.headerDropdownEls.forEach((item, i) => {
      const menuEl = getElement(".dropdown-menu", item);
      const toggleEl = getElement(".dropdown-toggle", item);
      const backLinkEl = getElement(".dropdown-menu__back-link", item);
      const closeBtnEl = getElement(".dropdown-menu__close-btn", item);

      closeBtnEl.addEventListener("click", (e) => {
        stopAndPrevent(e);
        this.closeNavbar();
      });
      addGlobalListeners(
        "resize",
        () => {
          this.setHeight(menuEl);
        },
        `headerDropdownLinks${i}`
      );

      backLinkEl.addEventListener("click", this.closeSubmenu.bind(this));
      toggleEl.addEventListener("click", async (e) => {
        stopAndPrevent(e);
        if (this.inProgress) {
          return;
        }
        if (this.lastOpenedLink && this.lastOpenedLink.toggleEl === toggleEl) {
          this.closeSubmenu();
          return;
        } else if (
          this.lastOpenedLink &&
          this.lastOpenedLink.item.contains(e.target)
        ) {
          return;
        } else if (this.lastOpenedLink) {
          this.closeSubmenu();
        }

        this.setHeight(menuEl);
        menuEl.classList.add("show");
        this.lastOpenedLink = { item, menuEl, toggleEl };
      });
    });
  }

  async openNavbar() {
    this.inProgress = true;
    backdrop.open();
    this.rootEl.classList.add("header-white");
    this.navEl.classList.remove("navbar-dark");
    this.collapseEl.classList.add("show");
    this.toggleEls.forEach((el) => el.setAttribute("aria-expanded", "true"));
    this.collapseOffsetHeight = this.collapseEl.offsetHeight;

    this.collapseEl.classList.add("collapsing");
    await new Promise((res) => setTimeout(res, 0));
    css(this.collapseEl, { minHeight: `${this.collapseOffsetHeight}px` });

    await new Promise((res) => setTimeout(res, this.animationDuration));
    this.collapseEl.classList.remove("collapsing");
    this.inProgress = false;
    this.isOpen = true;
  }

  async closeNavbar() {
    this.inProgress = true;
    backdrop.hide();
    this.collapseEl.classList.add("collapsing");
    this.collapseEl.style.minHeight = "";
    this.toggleEls.forEach((el) => el.setAttribute("aria-expanded", "false"));

    await new Promise((res) => setTimeout(res, this.animationDuration));
    this.collapseEl.classList.remove("show");
    this.collapseEl.classList.remove("collapsing");

    this.inProgress = false;
    this.isOpen = false;

    document.documentElement.classList.remove("navbar-header");
    this.rootEl.classList.remove("header-white");
    this.headerFixing();
    this.closeSubmenu();

    this.headerDropdownEls.forEach((item) => {
      const menuEl = getElement(".dropdown-menu", item);
      this.setHeight(menuEl);
    });
  }

  closeSubmenu() {
    if (this.lastOpenedLink) {
      this.lastOpenedLink.menuEl.classList.remove("show");
      this.collapseEl.style.minHeight = `${this.collapseOffsetHeight}px`;
      this.lastOpenedLink = null;
    }
  }

  clickOutside(e) {
    if (
      !e.target.closest(".dropdown") &&
      window.matchMedia(this.mediaTransfor).matches
    ) {
      this.closeSubmenu();
    }
    if (e.target === document.body) {
      this.closeNavbar();
    }
  }

  setHeight(menuEl) {
    setTimeout(() => {
      if (this.navEl.offsetHeight !== menuEl.scrollHeight) {
        // 24 is padding top + bottom
        this.collapseEl.style.minHeight = `${
          this.collapseOffsetHeight +
          (menuEl.scrollHeight + 24 - this.navEl.offsetHeight)
        }px`;
      } else {
        this.collapseEl.style.minHeight = "unset";
      }
    }, 10);
  }
}

const initHeaderNavigation = () => {
  const navbarHeaderEl = getElement("#headerNavbar");
  if (navbarHeaderEl) {
    const navbarHeader = new HeaderNavbar(getElement("#headerNavbar"));
    navbarHeader.init();

    return navbarHeader;
  }
};
/* Header dropdown end */

/* Scroller end */
const initScrollers = (navbarHeader) => {
  Array.from(getElements(".scroller")).forEach((el) => {
    el.addEventListener("click", () => {
      navbarHeader.closeNavbar();
    });
  });
};
/* Scroller end */

/* Gallery start */
function slideChange(that, slide) {
  const currentGallery = that.closest(".gallery");
  const currentSlideNumber = slide;
  const currentGalleryImage = getElements(
    ".gallery-image-container-in",
    currentGallery
  );
  const currentGalleryText = getElements(
    ".gallery-text-position",
    currentGallery
  );

  currentGallery.dataset.current = slide;

  for (let i = 0; i < currentGalleryImage.length; ++i) {
    currentGalleryImage[i].classList.add("opacity-0");
    currentGalleryImage[currentSlideNumber].classList.remove("opacity-0");
  }
  for (let i = 0; i < currentGalleryText.length; ++i) {
    currentGalleryText[i].classList.add("d-none");
    currentGalleryText[currentSlideNumber].classList.remove("d-none");
  }

  const button = getElements(".gallery-buttons button", currentGallery);
  const pagerButton = getElements(".pager-link", currentGallery);
  for (let i = 0; i < button.length; ++i) {
    button[i].classList.remove("btn-primary");
    button[i].classList.add("btn-light");
    button[currentSlideNumber].classList.remove("btn-light");
    button[currentSlideNumber].classList.add("btn-primary");

    pagerButton[i].classList.remove("active");
    pagerButton[currentSlideNumber].classList.add("active");
  }
}

const initGallery = () => {
  const galleryImage = getElements(".gallery-image-container-in");
  if (galleryImage && galleryImage.length) {
    const slideChanger = getElements(".slideChange");
    for (let k = 0; k < slideChanger.length; ++k) {
      slideChanger[k].addEventListener("click", function () {
        slideChange(this, this.dataset.number);
      });
    }

    for (let j = 0; j < galleryImage.length; ++j) {
      const currentGallery = galleryImage[j].closest(".gallery");
      currentGallery.dataset.current = 0;
      const swiper = new Swipe(galleryImage[j]);
      const currentGalleryImage = getElements(
        ".gallery-image-container-in",
        currentGallery
      );
      swiper
        .onLeft(function () {
          const curr = Number(currentGallery.dataset.current);
          const next = curr + 1 < currentGalleryImage.length ? curr + 1 : 0;
          slideChange(galleryImage[j], next);
        })
        .run();
      swiper
        .onRight(function () {
          const curr = Number(currentGallery.dataset.current);
          const next =
            curr - 1 >= 0 ? curr - 1 : currentGalleryImage.length - 1;
          slideChange(galleryImage[j], next);
        })
        .run();
    }
  }
};
/* Gallery end */

/* Rating start */
const initRating = () => {
  const starsRating = getElements(".stars-outer");
  const starsTotal = 5;

  if (starsRating && starsRating.length) {
    for (let i = 0; i < starsRating.length; ++i) {
      const starPercentage = (starsRating[i].dataset.rating / starsTotal) * 100;
      const starPercentageRounded = `${Math.round(starPercentage / 10) * 10}%`;
      getElement(".stars-inner", starsRating[i]).style.width =
        starPercentageRounded;
    }
  }

  const starsRatingOutlined = getElements(".stars-outlined");
  if (starsRatingOutlined && starsRatingOutlined.length) {
    for (let i = 0; i < starsRatingOutlined.length; ++i) {
      const starPercentage =
        (starsRatingOutlined[i].dataset.rating / starsTotal) * 100;
      getElement(
        ".stars-inner",
        starsRatingOutlined[i]
      ).style.width = `${starPercentage}%`;
    }
  }
};
/* Rating end */

/* FAQ start */
const initFAQ = () => {
  const acc = getElements(".faq__header");
  if (acc && acc.length) {
    for (let i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        if (this.parentNode.classList.contains("faq__position__active")) {
          this.nextElementSibling.style.maxHeight = null;
          this.parentNode.classList.remove("faq__position__active");
        } else {
          for (let j = 0; j < acc.length; j++) {
            acc[j].parentNode.classList.remove("faq__position__active");
            acc[j].nextElementSibling.style.maxHeight = null;
          }
          this.parentNode.classList.add("faq__position__active");
          const panel = this.nextElementSibling;
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  }
};
/* FAQ end */

const initilisedSelects = [];
/* Select start */
const initSelect = (elem, elems, callback) => {
  if (initilisedSelects.includes(elem)) return;
  initilisedSelects.push(elem);
  const selectHolder = getElement(".holder", elem);
  const selectHolderInput = getElement(".holder__input", elem);
  const selectOptions = getElements(".select__options li", elem);
  const dropHolder = getElement(".select__dropdown", elem);
  const initialSelectedOption = Array.from(selectOptions).find((el) =>
    el.classList.contains("current")
  );
  let selectedOption = initialSelectedOption || selectOptions[0];

  const selectSearch = getElement(".select__options__search", elem);
  const selectSearchInput = getElement(".select__options__search input", elem);

  const currentSelected = getElement(".current", elem);
  if (currentSelected) {
    selectHolder.innerHTML = currentSelected.innerHTML;
    selectHolderInput.value = /select/i.test(selectHolder.textContent)
      ? ""
      : currentSelected.dataset.val;
  }

  if (!initialSelectedOption && selectedOption) {
    selectedOption.classList.add("current");
  }

  addGlobalListeners("click", () => {
    elem.classList.remove("active");
  });
  selectHolder.addEventListener("click", (event) => {
    event.stopPropagation();

    if (elem.getAttribute("data-click") == 0) {
      elem.setAttribute("data-click", 1);
    }

    if (elem.classList.contains("active")) {
      elem.classList.remove("active");
    } else {
      for (let k = 0; k < elems.length; k++) {
        elems[k].classList.remove("active");
      }
      initilisedSelects.forEach((el) => el.classList.remove("active"));
      elem.classList.add("active");
      if (selectSearch) {
        selectSearchInput.focus();
      }
    }
  });

  selectOptions.forEach((currentElement) => {
    currentElement.addEventListener("click", () => {
      selectedOption.classList.remove("current");
      selectedOption = currentElement;
      currentElement.classList.add("current");
      selectHolder.innerHTML = currentElement.innerHTML;
      selectHolderInput.value = currentElement.dataset.val;
      let event = new Event("input", {
        bubbles: true,
        cancelable: true,
      });
      selectHolderInput.dispatchEvent(event);
      dropHolder.classList.toggle("active");

      if (
        selectedOption.getAttribute("data-link") != null &&
        selectedOption.getAttribute("data-link") != undefined
      ) {
        window.location.href = selectedOption.getAttribute("data-link");
      }

      if (callback) {
        callback(currentElement);
      }
    });
  });

  if (selectSearch) {
    selectSearch.addEventListener("click", (event) => {
      event.stopPropagation();
    });
    selectSearchInput.value = "";

    selectSearchInput.addEventListener("input", (e) => {
      const searchTerm = e.target.value;
      const regex = new RegExp(`(${searchTerm})`, "gi");
      const replacement = '<span class="highlighted">$1</span>';

      for (const li of selectOptions) {
        if (li.classList.contains("calc_search_li")) {
          if (
            regex.test(li.querySelector(".calc_li_text_content").innerText) &&
            !li.classList.contains("used")
          ) {
            li.style.display = "block";
            li.querySelector(".calc_li_text_content").innerHTML = li
              .querySelector(".calc_li_text_content")
              .innerText.replace(regex, replacement);
          } else {
            li.style.display = "none";
          }
        } else {
          if (regex.test(li.innerText)) {
            li.style.display = "block";
            li.innerHTML = li.innerText.replace(regex, replacement);
          } else {
            li.style.display = "none";
          }
        }
      }
    });
  }
};

const selectTab = (setFocus) => {
  const tabs = getElements(".calc__line--tab");
  const selectTab = getElement('input[name="message-tabs"]:checked').value;
  
  for (let i = 0; i < tabs.length; ++i) {
    if (tabs[i].dataset.tab === selectTab) {
      tabs[i].classList.add("calc__line--opened");
      tabs[i].classList.remove("calc__line--closed");

      let holder__input = getElement(".holder__input", tabs[i]);
      let event = new Event("input", {
        bubbles: true,
        cancelable: true,
      });
      let dataSidebarId = tabs[i].getAttribute("data-sidebar-id");
      tabs[i].classList.add("active-in-sidebar");
      let hiddenSidebarItemSlector = getElement(
        '.calc-right [data-id="' + dataSidebarId + '"]'
      );
      holder__input.dispatchEvent(event);

      if (ifItemExist(hiddenSidebarItemSlector)) {
        hiddenSidebarItemSlector.classList.remove("hidden");
      } else {
        var calcRightHtml = document.querySelector('.calculator_results').innerHTML;                    
        if(calcRightHtml.indexOf('Send texts via CPaaS') === -1 && selectTab == 'cpaas-provider')  
          createLiElementPhoneData(tabs[i]); 
        else if(selectTab != 'cpaas-provider')
          createLiElementPhoneData(tabs[i]); 
      }

      if (setFocus) {
        const currentLineField = getElement(".calc__line-field", tabs[i]);
        if (ifItemExist(currentLineField)) {
          currentLineField.focus();

          // Move cursor to the end of the input value
          const valueLength = currentLineField.value.length;
          currentLineField.setSelectionRange(valueLength, valueLength);
        }
      }

      calculatePrice();
    } else {
      tabs[i].classList.add("calc__line--closed");
      tabs[i].classList.remove("calc__line--opened");

      let dataSidebarIdDefault = tabs[i].getAttribute("data-sidebar-id");
      let dataSidebarIdPhone = tabs[i].getAttribute("data-additional-id");
      tabs[i].classList.remove("active-in-sidebar");
      deleteLiElement(dataSidebarIdDefault, dataSidebarIdPhone);
      calculatePrice();
    }
  }
};

const addFirstLine = () => {
  const tabs = getElements(".calc__line--tab");
  if (tabs.length > 0) {
    return;
  }

  const addServiceButton = getElement("button.add_service");
  if (addServiceButton) {
    addServiceButton.click();
  }
};

const initTabs = () => {
  const messagesDispatchedTab = getElements('input[name="message-tabs"]')
  if (messagesDispatchedTab && messagesDispatchedTab.length) {
    selectTab(false);
    for (let i = 0; i < messagesDispatchedTab.length; ++i) {
      messagesDispatchedTab[i].addEventListener('change', () => {
        selectTab(true);
      });
    }
  }

  const collapseInfo = getElements(".collapsible-info")
  if (collapseInfo && collapseInfo.length) {
    for (let i = 0; i < collapseInfo.length; ++i) {
      const collapseInfoHeader = getElement(".collapsible-info__header", collapseInfo[i])
      collapseInfoHeader.addEventListener('click', () => {
        if (collapseInfo[i].classList.contains('opened')) {
          collapseInfo[i].classList.remove('opened')
        } else {
          collapseInfo[i].classList.add('opened')
        }
      })
    }
  }
};

const initSelects = (callback) => {
  const select = getElements(".select");
  if (select && select.length) {
    for (let i = 0; i < select.length; i++) {
      initSelect(select[i], select, callback);
    }
  }
};
/* Select end */

/* Social position start */
const initSocialsPosition = () => {
  const socials = getElement(".blog__socials");
  const socialRelative = getElement(".social-relative");

  if (socials && socialRelative) {
    const headerOffset = 24;

    const setPosition = () => {
      const headerHeight = getElement(".header").offsetHeight;
      const socialsHeight = socials.offsetHeight;
      const socialRelativeOffset = parseInt(
        window.getComputedStyle(socialRelative)["margin-bottom"],
        10
      );
      const { top: blogListTop, height: blogListHeight } =
        socialRelative.getBoundingClientRect();
      const topOffset = Math.round(blogListTop - headerHeight - headerOffset);
      if (topOffset < 0) {
        if (
          blogListHeight -
            Math.abs(topOffset) -
            socialsHeight -
            socialRelativeOffset <
          0
        ) {
          css(socials, {
            top: `${blogListHeight - socialsHeight - socialRelativeOffset}px`,
          });
        } else {
          css(socials, {
            top: `${Math.abs(topOffset)}px`,
          });
        }
      } else {
        css(socials, {
          top: "0",
        });
      }
    };

    setTimeout(() => {
      setPosition();
      addGlobalListeners("scroll", setPosition);
    }, 100);
  }

  const copyLink = getElement(".copy_link");
  if (copyLink) {
    copyLink.addEventListener("click", function () {
      navigator.clipboard.writeText(window.location.href);
      copyLink.dataset.tooltip = "Copied";
      setTimeout(function () {
        copyLink.dataset.tooltip = "Copy";
      }, 1000);
    });
  }
};
/* Social position end */

/* Media Gallery start */
const initMediaGallery = () => {
  const media = getElement(".media__image");

  if (media) {
    glightbox({
      selector: ".media__image",
    });
  }
};
/* Media Gallery end */

/* Scroll Top start */
const initScrollTop = () => {
  const scrollTopButton = getElement(".scrollTop");
  if (scrollTopButton) {
    const scrollFunc = function () {
      const y = window.scrollY;
      if (y >= 400) {
        scrollTopButton.className = "scrollTop show";
      } else {
        scrollTopButton.className = "scrollTop";
      }
    };
    addGlobalListeners("scroll", scrollFunc);
  }
};
/* Scroll Top end */

/* Upload start */
const initUploadArea = () => {
  const setting = {
    isFileUploaded: "",
  };
  const area = getElement(".upload-area");
  if (area) {
    const areaInit = getElement(".upload-area__init", area);
    const areaFile = getElement(".upload-area__file", area);
    const areaFileName = getElement(".upload-area__file-name", area);
    const areaFileIcon = getElement(".upload-area__file-icon", area);
    const areaChangeBtn = getElement(".upload-area__file-btn-change", area);
    const areaRemoveBtn = getElement(".upload-area__file-btn-remove", area);
    const fileInput = getElement("input", area);

    const clearIconClass = () => {
      areaFileIcon.classList.remove("_pdf");
      areaFileIcon.classList.remove("_img");
      areaFileIcon.classList.remove("_doc");
    };
    const setIconClass = (fileType) => {
      clearIconClass();
      if (
        fileType.includes("msword") ||
        fileType.includes(
          "vnd.openxmlformats-officedocument.wordprocessingml.document"
        )
      ) {
        areaFileIcon.classList.add("_doc");
      } else if (fileType.includes("image")) {
        areaFileIcon.classList.add("_img");
      } else {
        areaFileIcon.classList.add("_pdf");
      }
    };
    const openFileInput = () => {
      fileInput.click();
    };
    const setFileSettings = (file) => {
      if (file) {
        setting.isFileUploaded = true;
        areaInit.classList.add("hidden");
        areaFile.classList.remove("hidden");
        areaFileName.innerHTML = file.name;
        setIconClass(file.type);
      } else {
        setting.isFileUploaded = false;
        areaInit.classList.remove("hidden");
        areaFile.classList.add("hidden");
        clearIconClass();
      }
    };

    area.ondragover = area.ondragenter = (evt) => {
      evt.preventDefault();
    };
    area.ondrop = (evt) => {
      fileInput.files = evt.dataTransfer.files;
      setFileSettings(evt.dataTransfer.files[0]);
      area.classList.remove("_dragging");
      evt.preventDefault();
    };
    area.addEventListener("click", () => {
      if (!setting.isFileUploaded) {
        openFileInput();
      }
    });
    area.addEventListener("dragover", () => {
      area.classList.add("_dragging");
    });
    area.addEventListener("dragleave", () => {
      area.classList.remove("_dragging");
    });
    areaChangeBtn.addEventListener("click", (evt) => {
      openFileInput();
      evt.stopPropagation();
    });
    areaRemoveBtn.addEventListener("click", (evt) => {
      evt.stopPropagation();
      fileInput.value = "";
      setFileSettings();
    });
    fileInput.addEventListener("change", () => {
      setFileSettings(fileInput.files[0]);
    });
  }
};
/* Upload end */

/* Textarea start */
const initTextarea = () => {
  const tx = document.getElementsByTagName("textarea");
  function OnInput() {
    if (this.scrollHeight < 600) {
      this.style.height = "auto";
      this.style.height = this.scrollHeight + "px";
      this.style.overflowY = "hidden";
    } else {
      this.style.height = "auto";
      this.style.height = "600px";
      this.style.overflowY = "auto";
    }
  }
  if (tx) {
    for (let i = 0; i < tx.length; i++) {
      if (tx[i].scrollHeight < 600) {
        tx[i].setAttribute(
          "style",
          "height:" + tx[i].scrollHeight + "px;overflow-y:hidden;"
        );
      } else {
        tx[i].setAttribute("style", "height:600px;overflow-y:auto;");
      }
      tx[i].addEventListener("input", OnInput, false);
    }
  }
};
/* Textarea end */

/* initTextareaCopy start */
const initCopyToClipboard = () => {
  const copyToClipboard = (e) => {
    const r = document.createRange();
    r.selectNode(getElement(`#${e.dataset.target}`));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  };

  const btns = Array.from(getElements('[data-type="copy-to-clipboard"]'));
  btns.forEach((el) => {
    el.addEventListener("click", copyToClipboard);
  });
};

const initTextareaCopy = () => {
  const copyTextBtn = getElement("#alertCopyBtn");
  if (copyTextBtn) {
    copyTextBtn.addEventListener("click", function () {
      const alertCopyBtnText = getElement("#alertCopyBtnText");
      alertCopyBtnText.innerText = "Copied";
      setTimeout(function () {
        alertCopyBtnText.innerText = "Copy text";
      }, 1000);
    });
  }
};
/* initTextareaCopy end */

/* initFormLineValidation start */
const initFormLineValidation = () => {
  const formLine = getElements(".form-line");
  if (formLine && formLine.length) {
    for (let i = 0; i < formLine.length; ++i) {
      const input = getElement(".form-control", formLine[i]);
      const button = getElement(".btn", formLine[i]);
      button.addEventListener("click", function () {
        if (input.value) {
          this.parentNode.classList.remove("has-error");
        } else {
          this.parentNode.classList.add("has-error");
        }
      });
      input.addEventListener("keyup", function () {
        this.parentNode.parentNode.classList.remove("has-error");
      });
    }
  }
};
/* initFormLineValidation end */

/* initSurveySteps start */
const initSurveySteps = () => {
  function stepChange(
    curr,
    surveyProgress,
    surveyStep,
    backButton,
    surveyCurrentStep,
    surveyStepRight
  ) {
    surveyProgress.style.width = (100 / surveyStep.length) * curr + "%";
    backButton.dataset.step = curr;
    surveyCurrentStep.innerHTML = curr;
    if (curr == 1) {
      backButton.classList.remove("show");
    } else {
      backButton.classList.add("show");
    }
    for (let i = 0; i < surveyStep.length; ++i) {
      surveyStep[i].classList.remove("show");
    }
    surveyStep[curr - 1].classList.add("show");

    for (let i = 0; i < surveyStepRight.length; ++i) {
      surveyStepRight[i].classList.remove("show");
    }
    surveyStepRight[curr - 1].classList.add("show");
  }

  const surveyStep = getElements(".survey__step");
  if (surveyStep && surveyStep.length) {
    let currentStep = 1;
    const backButton = getElement("#surveyBackLink");
    const nextButton = getElements(".nextButton");
    const surveyCurrentStep = getElement("#surveyCurrentStep");
    const surveyTotalStep = getElement("#surveyTotalStep");
    const surveyStepRight = getElements(".survey__right-in");
    const surveyProgress = getElement("#surveyProgress");

    surveyProgress.style.width = 100 / surveyStep.length + "%";
    surveyCurrentStep.innerHTML = currentStep;
    surveyTotalStep.innerHTML = surveyStep.length;

    backButton.addEventListener("click", function () {
      currentStep -= 1;
      stepChange(
        currentStep,
        surveyProgress,
        surveyStep,
        backButton,
        surveyCurrentStep,
        surveyStepRight
      );
    });

    for (let i = 0; i < nextButton.length; ++i) {
      nextButton[i].addEventListener("click", function () {
        currentStep = this.dataset.next;
        if (currentStep == "success") {
          stepChange(
            1,
            surveyProgress,
            surveyStep,
            backButton,
            surveyCurrentStep,
            surveyStepRight
          );
          getElement(".survey").classList.remove("show");
          getElement(".survey-success").classList.add("show");
        } else {
          stepChange(
            currentStep,
            surveyProgress,
            surveyStep,
            backButton,
            surveyCurrentStep,
            surveyStepRight
          );
        }
      });
    }
  }
};
/* initSurveySteps end */

/* initCheckboxButtons start */
const initCheckboxButtons = () => {
  const checkboxButton = getElements(".checkbox-button");
  if (checkboxButton && checkboxButton.length) {
    for (let i = 0; i < checkboxButton.length; ++i) {
      checkboxButton[i].addEventListener("click", function () {
        if (checkboxButton[i].querySelector("input:checked")) {
          checkboxButton[i].classList.add("overflow-hidden");
        } else {
          checkboxButton[i].classList.remove("overflow-hidden");
        }
      });
    }
  }
};
/* initCheckboxButtons end */

/* initRangeSlider start */
const onInput = (rangeValue, ranger) => {
  const currentLine = ranger.closest(".calc__line");
  const currentLineField = getElements(".calc__line-field", currentLine);
  let minValue = 0;
  let maxValue = 0;
  if (currentLineField && currentLineField.length) {
    minValue = parseInt(currentLineField[currentLineField.length - 1].getAttribute("min"));
    maxValue = parseInt(currentLineField[currentLineField.length - 1].getAttribute("max"));
  }

  let cleanedValue = parseInt(rangeValue.replace(/\D/g, ""));
  let updateValue = true;

  if (isNaN(cleanedValue)) {
    cleanedValue = minValue;
    if (!rangeValue) {
      updateValue = false;
    }
  } else if (cleanedValue < minValue) {
    cleanedValue = minValue;
    updateValue = false;
  } else if (cleanedValue > maxValue) {
    cleanedValue = maxValue;
    updateValue = true;
  }

  ranger.style.setProperty("--value", cleanedValue);
  ranger.style.setProperty(
    "--text-value",
    '"' + cleanedValue.toLocaleString() + '"'
  );
  if (currentLineField && currentLineField.length && updateValue) {
    currentLineField[currentLineField.length - 1].value =
      cleanedValue.toLocaleString();
  }

  ranger.dispatchEvent(new Event('change'));
};

const initRangeSlider = () => {
  const range = getElements(".range-slider");
  if (range && range.length) {
    for (let i = 0; i < range.length; ++i) {
      const rangeInput = getElement("input", range[i]);

      if (range[i]) {
        rangeInput.addEventListener(
          "change",
          onInput(rangeInput.value, range[i])
        );
        rangeInput.addEventListener("input", () => {
          onInput(rangeInput.value, range[i]);
        });

        const rangeLine = range[i].closest(".calc__line");
        const rangeLineField = getElements(".calc__line-field", rangeLine);
        const lastRangeLineField = rangeLineField[rangeLineField.length - 1];
        if (lastRangeLineField) {
          for (let k = 0; k < rangeLineField.length; k++) {
            rangeLineField[k].onkeyup = () => {};
          }
          lastRangeLineField.onkeyup = () => {
            onInput(lastRangeLineField.value, range[i]);
          };
        }
      }
    }
  }
};
/* initRangeSlider end */

/* initCalcSlider start */
const initCalcSlider = () => {
  const calcLine = getElements(".calc__line");

  if (calcLine && calcLine.length) {
    for (let i = 0; i < calcLine.length; ++i) {
      const calcLineLink = getElement(".calc__line-link", calcLine[i]);

      if (calcLineLink) {
        calcLineLink.addEventListener("click", function () {
          calcLine[i].classList.add("calc__line--opened");

          const calcLineFields = getElements(".calc__line-field", calcLine[i]);
          if (calcLineFields && calcLineFields.length) {
            const lastInputField = calcLineFields[calcLineFields.length - 1];
            lastInputField.focus();

            // Move cursor to the end of the input value
            const valueLength = lastInputField.value.length;
            lastInputField.setSelectionRange(valueLength, valueLength);
          }
        });
      }

      const calcLineClose = getElement(".calc__line-close", calcLine[i]);
      if (calcLineClose) {
        calcLineClose.addEventListener("click", function () {
          calcLine[i].classList.remove("calc__line--opened");
        });
      }
    }
  }
};

/* initNumber start */
const initNumber = () => {
  const number = getElements(".number");
  if (number && number.length) {
    for (let i = 0; i < number.length; ++i) {
      const numberInput = getElement("input", number[i]);
      const numberMinus = getElement(".number__minus", number[i]);
      const numberPlus = getElement(".number__plus", number[i]);
      numberInput.addEventListener("input", () => {
        numberInput.value = numberInput.value
          .replace(/[^0-9.]/g, "")
          .replace(/(..*)\./g, "$1");
      });
      numberMinus.addEventListener("click", () => {
        numberInput.stepDown();
      });
      numberPlus.addEventListener("click", () => {
        numberInput.stepUp();
      });
    }
  }
};
/* initNumber end */

/* initTooltips start */
const initTooltips = () => {
  const tooltip = getElements(".tooltip");
  if (tooltip && tooltip.length) {
    const tooltipLink = getElements(".tooltip-link");
    for (let i = 0; i < tooltipLink.length; ++i) {
      tooltipLink[i].addEventListener("click", () => {
        if (tooltipLink[i].closest(".tooltip").classList.contains("active")) {
          tooltipLink[i].closest(".tooltip").classList.remove("active");
        } else {
          tooltipLink[i].closest(".tooltip").classList.add("active");
        }
      });

      const tooltip = getElements(".tooltip");
      for (let i = 0; i < tooltip.length; ++i) {
        addGlobalListeners("click", (e) => {
          if (!tooltip[i].contains(e.target)) {
            tooltip[i].classList.remove("active");
          }
        });
      }
    }
  }
};
/* initTooltips end */

/* initCalcLines start */
const setCalcLinesVars = (currentSelect) => {
  const currentSelectOption = getElement(".select__options .current", currentSelect);
  const val = currentSelectOption.dataset.val.toUpperCase();
  const serviceName = currentSelectOption.dataset.serviceName;
  const costPrice = getElement(".cost-value", currentSelect);
  costPrice.innerHTML = currentSelectOption.dataset.price;
  if (serviceName === 'SMS') {
    const numberCostPrice = getElements(".number-cost-value", currentSelect.closest('table').parentNode);
    for (let k = 0; k < numberCostPrice.length; ++k) {
      numberCostPrice[k].innerHTML = currentSelectOption.dataset.fixedPricePhone;
    }
    const inboundCostPrice = getElements(".receive-cost-value", currentSelect.closest('table').parentNode);
    for (let k = 0; k < inboundCostPrice.length; ++k) {
      inboundCostPrice[k].innerHTML = currentSelectOption.dataset.priceReceive;
    }
    const campaignCostPrice = getElements(".campaign-cost-value", currentSelect.closest('table').parentNode);
    for (let k = 0; k < campaignCostPrice.length; ++k) {
      campaignCostPrice[k].innerHTML = currentSelectOption.dataset.priceTenDlc;
    }

    const contentVal = ['US', 'CA'].includes(val) ? val : 'ALL';
    const complianceContent = getElements(".collapsible-info__content", currentSelect.closest('table').parentNode);
    for (let k = 0; k < complianceContent.length; ++k) {
      if (complianceContent[k].dataset.val === contentVal) {
        complianceContent[k].classList.remove('hidden');
      } else {
        complianceContent[k].classList.add('hidden');
      }
    }
  }
};

const initCalcLines = (currentSelect) => {
  setCalcLinesVars(currentSelect);
  const selectCountryOptions = getElements(
    ".select__options li",
    currentSelect
  );
  for (let k = 0; k < selectCountryOptions.length; ++k) {
    selectCountryOptions[k].addEventListener("click", () => {
      setCalcLinesVars(currentSelect);
    });
  }
};

const updateLineField = (closestTableBody, currentCalcLine, add = false) => {
  const calcFields = getElements(".calc__line-field", closestTableBody);
  const currentRange = getElement(".range-slider", currentCalcLine);

  if (add) {
    const val = calcFields[calcFields.length - 1].getAttribute("value");
    calcFields[calcFields.length - 1].value = val;
    onInput(val, currentRange);
  } else {
    onInput(calcFields[calcFields.length - 1].value, currentRange);
  }
};
/* initCalcLines end */

/* initNumberTable start */
const initNumberTable = () => {
  const numberTable = getElements(".calc__line-table");
  if (numberTable && numberTable.length) {
    for (let i = 0; i < numberTable.length; ++i) {
      const numberTemplate = getElement("template", numberTable[i]);
      const numberTableBody = getElement(".number-table-body", numberTable[i]);
      if (ifItemExist(numberTemplate) && ifItemExist(numberTableBody)) {
        numberTableBody.appendChild(numberTemplate.content.cloneNode(true));
      }

      initSelects();
      initRangeSlider();
      initCalcLines(numberTableBody);
    }

    const addNumberLink = getElements(".add-number-row");
    for (let i = 0; i < addNumberLink.length; ++i) {
      addNumberLink[i].addEventListener("click", (e) => {
        const currentCalcLine = addNumberLink[i].closest(".calc__line");
        const addNumberLinkCurrent =
          e.target.parentNode.parentNode.querySelector(".add_new_number");
        const closestTableBody = getElement(
          ".number-table-body",
          currentCalcLine
        );
        const numberTemplateRow = getElement("template", currentCalcLine);

        // TODO: merge with wp redesign
        let allPhoneNumbers = getElements("li", numberTemplateRow.content);
        let lineItem = currentCalcLine;
        Array.from(allPhoneNumbers).forEach((liItem, key) => {
          let itemDataVal = liItem.getAttribute("data-val");
          if (checkForCurrentLiValue(lineItem).includes(itemDataVal)) {
            liItem.classList.remove("current");
            if (
              liItem.nextElementSibling != undefined &&
              liItem.nextElementSibling != null
            ) {
              if (!allPhoneNumbers[0].classList.contains("current")) {
                liItem.nextElementSibling.classList.add("current");
                if (ifItemExist(liItem.nextElementSibling.nextElementSibling)) {
                  liItem.nextElementSibling.nextElementSibling.classList.remove(
                    "current"
                  );
                  if (
                    ifItemExist(
                      liItem.nextElementSibling.nextElementSibling
                        .nextElementSibling
                    )
                  ) {
                    liItem.nextElementSibling.nextElementSibling.nextElementSibling.classList.remove(
                      "current"
                    );
                  }
                }
              }
            }
          }
        });
        let usedPhoneNumbers = getElements(".select__options", currentCalcLine);

        if (usedPhoneNumbers.length == allPhoneNumbers.length - 1) {
          addNumberLinkCurrent.classList.add("hidden");
          addNumberLinkCurrent.disabled = true;
        } else {
          addNumberLinkCurrent.classList.remove("hidden");
          addNumberLinkCurrent.disabled = false;
        }
        // TODO: end
        closestTableBody.appendChild(numberTemplateRow.content.cloneNode(true));
        // TODO: merge with wp redesign
        const randHiddenId = Math.floor(Math.random() * 100000);
        getElement(
          ".holder__input",
          closestTableBody.lastElementChild
        ).setAttribute("data-rand-id", randHiddenId);
        // const newTrLength = getElements('tr', closestTableBody).length;
        const newTrLength = getRandomInt(10000);
        closestTableBody.lastElementChild.setAttribute(
          "data-new-tr-id",
          newTrLength
        );
        // end
        const deleteNumberLink = getElements(".row-delete-button");
        for (let j = 0; j < deleteNumberLink.length; ++j) {
          deleteNumberLink[j].addEventListener("click", (e) => {
            e.stopPropagation();
            let parentTr = e.target.closest("tr");
            let virtualNumberToDeleteSelector = getElement(
              'div[data-new-tr-id="' +
                parentTr.getAttribute("data-new-tr-id") +
                '"]'
            );

            let lineItem = getElement(
              '.phone_line[data-additional-id="' +
                parentTr.getAttribute("data-additional-id") +
                '"]'
            );
            let holderInput = getElement(".holder__input", parentTr);
            if (ifItemExist(virtualNumberToDeleteSelector)) {
              virtualNumberToDeleteSelector.remove();
            }
            deleteUsedCountries(lineItem, holderInput, true);
            calculatePrice();

            let calcLine = deleteNumberLink[j].closest(".calc__line");
            let addNewNumber = getElement(".add_new_number", calcLine);
            if (addNewNumber != null && addNewNumber != undefined) {
              addNewNumber.classList.remove("hidden");
              addNumberLinkCurrent.disabled = false;
            }
            deleteNumberLink[j].closest("tr").remove();

            // TODO: merge with wp redesign
            updateLineField(closestTableBody, currentCalcLine);
          });
        }

        initSelects();
        initRangeSlider();
        updateLineField(closestTableBody, currentCalcLine, true);

        const selectCountry = getElements(".select", currentCalcLine);
        for (let j = 0; j < selectCountry.length; ++j) {
          initCalcLines(selectCountry[j].closest("tr"));
        }
      });
    }
  }
};
/* initNumberTable end */

/* initModal start */
const initModal = () => {
  const modalLinks = getElements("[data-modal]");
  if (modalLinks && modalLinks.length) {
    for (let i = 0; i < modalLinks.length; ++i) {
      modalLinks[i].addEventListener("click", () => {
        const modal = getElement(modalLinks[i].dataset.modal);
        modal.classList.add("show");
        document.body.classList.add("modal-show");
      });
    }
  }

  function closeModal(el) {
    el.closest(".modal").classList.remove("show");
    document.body.classList.remove("modal-show");
  }

  const modalBackdrops = getElements(".modal-backdrop");
  if (modalBackdrops && modalBackdrops.length) {
    for (let i = 0; i < modalBackdrops.length; ++i) {
      modalBackdrops[i].addEventListener("click", () => {
        closeModal(modalBackdrops[i]);
      });
    }
  }

  const modalClose = getElements(".modal-close");
  if (modalClose && modalClose.length) {
    for (let i = 0; i < modalClose.length; ++i) {
      modalClose[i].addEventListener("click", () => {
        closeModal(modalClose[i]);
      });
    }
  }
};
/* initModal end */

/* initCollapsibleSearch start */
const initCollapsibleSearch = () => {
  const collapsibleSearch = getElement(".search--collapsible");

  if (collapsibleSearch) {
    const input = getElement(".form-control", collapsibleSearch);
    input.addEventListener("focus", () => {
      collapsibleSearch.classList.add("focused");
    });

    const closeBtn = getElement(".search__btn-close", collapsibleSearch);
    closeBtn.addEventListener("click", () => {
      collapsibleSearch.classList.remove("focused");
    });
  }
};
/* initCollapsibleSearch end */

/* initAccordion start */
const initAccordion = () => {
  const accordionRow = getElements(".collapsible-line");

  function collapsingAccordion() {
    const collapseButton = getElement(".collapse-btn");
    if (collapseButton) {
      collapseButton.addEventListener("click", () => {
        if (collapseButton.classList.contains("expand")) {
          collapseButton.classList.remove("expand");
          for (let i = 0; i < accordionRow.length; ++i) {
            accordionRow[i].classList.add("opened");
          }
        } else {
          collapseButton.classList.add("expand");
          for (let i = 0; i < accordionRow.length; ++i) {
            accordionRow[i].classList.remove("opened");
          }
        }
      });
    }
  }

  if (accordionRow && accordionRow.length) {
    collapsingAccordion();
    for (let i = 0; i < accordionRow.length; ++i) {
      accordionRow[i].classList.add("opened");
      const collapsibleHeader = getElement(
        ".collapsible-header",
        accordionRow[i]
      );
      collapsibleHeader.addEventListener("click", () => {
        if (accordionRow[i].classList.contains("opened")) {
          accordionRow[i].classList.remove("opened");
        } else {
          accordionRow[i].classList.add("opened");
        }
      });
    }
  }
};
/* initAccordion end */

/* initCookiesBannerClose start */
const initCookiesBannerClose = () => {
  const cookiesBanner = getElement(".cookies");
  if (cookiesBanner) {
    const cookiesAccept = getElement("#cookiesAccept");
    cookiesAccept.addEventListener("click", () => {
      cookiesBanner.classList.add("hide");
    });
  }
};
/* initCookiesBannerClose end */

const init = () => {
  const navbarHeader = initHeaderNavigation();
  initScrollers(navbarHeader);
  initGallery();
  initCopyToClipboard();
  initRating();
  initFAQ();
  initSocialsPosition();
  initMediaGallery();
  initScrollTop();
  initUploadArea();
  initTextarea();
  initTextareaCopy();
  initFormLineValidation();
  initSurveySteps();
  initCheckboxButtons();

  initModal();
  initCollapsibleSearch();
  initAccordion();
  initCookiesBannerClose();

  setTimeout(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, 100);
};

ready(init);

jQuery(document).ready(function ($) {
  let allData;
  let allMonthlyData;
  let currentPrice;

  let cost_per_month;
  let selectedClass = "US";
  let selectedClass2 = "US";
  let selectedClass3 = "US";
  let selectedClass4 = "carrier_lookup";
  let selectedClass5 = "US";

  let options = {
    templateSelection: custom_template,
    templateResult: custom_template,
  };
   
  if (typeof countryCode !== "undefined" && countryCode != "") {
    if (typeof showMonthly !== "undefined" && showMonthly) {
      getNewPricingData(); 
    } else { 
      getPricingData();
    }
  }
  //currency select
  const customSelect = () => {
    const select = document.getElementById("custom-select");
    $("#custom-select").on("change", function (e) {
      mainSelectedCurrency = e.target.value;
      currentCurrency = e.target.value;
      $(".global-dynamic-currency").text(currencySymbols[mainSelectedCurrency]);
      $("template")
        .contents()
        .find(".global-dynamic-currency")
        .text(currencySymbols[mainSelectedCurrency]);

      // $(".number-table-body ul").innerHTML("");
      const tableUls = document.querySelectorAll(".number-table-body ul");
      Array.from(tableUls).forEach((customUl) => {
        const tableLis = customUl.querySelectorAll("li");
        let selectedPrice = ""; // this price we will set inside of selected

        //get ul attributes
        const ulData = customUl.getAttribute("data-type").split(" ");
        //get ul data-type
        //create custom li
        Array.from(tableLis).forEach((customLi) => {
          let title = customLi.getAttribute("data-val").toUpperCase();
          if (!allData[title]) {
            title = "US";
          }
          if (ulData[1] === "lookup") {
            ulData[1] = "carrier_lookup";
            ulData[2] = "carrier_lookup";
          }
          const dataCountry = allData[title].prices[mainSelectedCurrency];
          if (Array.from(customLi.classList).includes("current")) {
            selectedPrice = dataCountry[ulData[1]].split(
              currencySymbols[mainSelectedCurrency]
            )?.[1];
          }
          customLi.setAttribute(
            "data-fixed-price-phone",
            dataCountry[ulData[2]].split(
              currencySymbols[mainSelectedCurrency]
            )?.[1]
          );

          customLi.setAttribute(
            "data-price",
            dataCountry[ulData[1]].split(
              currencySymbols[mainSelectedCurrency]
            )?.[1]
          );

          if (ulData[0] === 'SMS') {
            customLi.setAttribute(
                "data-price-receive",
                dataCountry['receive'].split(
                    currencySymbols[mainSelectedCurrency]
                )?.[1]
            );
            customLi.setAttribute(
                "data-price-ten-dlc",
                dataCountry['10dlc_registration'].split(
                    currencySymbols[mainSelectedCurrency]
                )?.[1]
            );
          }
        });

        let closestHolderInput =
          customUl.parentNode.parentNode.querySelector(".holder__input");
        updateCurrentPhoneData(
          customUl.closest(".phone_line"),
          closestHolderInput,
          true
        );
        deleteUsedCountries(
          customUl.closest(".phone_line"),
          closestHolderInput
        );
        setCalcLinesVars(customUl.closest("tr"));
      });
      dynamicPrices(allData);
      addNewListOfPaygItem(allData);
      calculatePrice();
    });
    // add select items
    const currency = Object.keys(currencySymbols);
    currency.map((item) => {
      $("<option />")
        .attr("value", item)
        .attr("class", "custom-select-option pricing-plans-price-text")
        .text(item)
        .appendTo(select);
    });
  };
  customSelect();

  // Add Dynamic Prices
  const dynamicPrices = (allData) => {
    const getFirstCountry = Object.keys(allData)[0].toUpperCase();
    const data = allData[getFirstCountry].prices[mainSelectedCurrency];
    const dataMMS = allData.CA.prices[mainSelectedCurrency]; 
    
    $(".sms-inbound-price").html(data.receive); 
    $(".mms-inbound-price").html(dataMMS.mms); 
    $(".voice-inbound-price").html(data.inbound_call);  
  };
  //Add new li in Select

  function createCustomPaygLi(customUl, title, allData, isActive, isUsed) {
    allData[title].prices[mainSelectedCurrency].inbound_call = allData[title].prices[mainSelectedCurrency].outbound_call;//Voice change to outbound!
    allData[title].prices.EUR.inbound_call = allData[title].prices.EUR.outbound_call;
    allData[title].prices.GBP.inbound_call = allData[title].prices.GBP.outbound_call;
    allData[title].prices.AUD.inbound_call = allData[title].prices.AUD.outbound_call;


    const dataCountry = allData[title].prices[mainSelectedCurrency];
    //get ul attributes
    const ulData = customUl.getAttribute("data-type").split(" ");
    //get ul data-type
    const ulDataType = ulData[0];
    //create custom li
    let li = $("<li />")
      .attr(
        "class",
        `calc_search_li ${isActive ? "current " : ""} ${isUsed ? "used" : ""}`
      )
      .attr("data-val", title.toLowerCase())
      .attr(
        "data-fixed-price-phone",
        dataCountry[ulData[2]].split(currencySymbols[mainSelectedCurrency])?.[1]
      )
      .attr("data-service-name", ulDataType)
      .attr("data-sidebar", "%price% for %amount% %service_name%")
      .attr("data-phone-description", "%price% for 1 number (%acronim%)")
      .attr(
        "data-price",
        dataCountry[ulData[1]].split(currencySymbols[mainSelectedCurrency])?.[1]
      );
    if (ulDataType === 'SMS') {
      li.attr(
          "data-price-receive",
          dataCountry['receive'].split(currencySymbols[mainSelectedCurrency])?.[1]
      );
      li.attr(
          "data-price-ten-dlc",
          dataCountry['10dlc_registration'].split(currencySymbols[mainSelectedCurrency])?.[1]
      );
    }

    li.appendTo(customUl);
    addCountryLine(li, title);
  }

  function createCustomMonthlyLi(customUl, title, isActive, isUsed) {
    //get ul attributes
    const ulData = customUl.getAttribute("data-type").split(" ");
    //get ul data-type
    const ulDataType = ulData[0];

    let li = $("<li />")
        .attr(
            "class",
            `calc_search_li ${isActive ? "current " : ""} ${isUsed ? "used" : ""}`
        )
        .attr("data-val", title.toLowerCase())
        .attr("data-service-name", ulDataType)
        .appendTo(customUl);
    addCountryLine(li, title);
  }

  function addCountryLine(li, title){
    let countryLine = $("<div />").attr("class", "country-line").appendTo(li);
    let flag = $("<div />").attr("class", "flag").appendTo(countryLine);
    let img = '';
    if(title.toLowerCase() == 'cy') {
      img = $("<img />")
        .attr(
            "src",
            "/wp-content/themes/textmagic-new/assets/img/pricing/cyprus_sm2.png"
        )
        .attr("alt", "flag")
        .attr("class", `flag__img`)
        .appendTo(flag);
    }
    else {
      img = $("<img />")
        .attr(
            "src",
            "/wp-content/themes/textmagic-new/assets/img/flag_placeholder.webp"
        )
        .attr("alt", "flag")
        .attr("class", `flag__img ${title.toLowerCase()}`)
        .appendTo(flag);
      }
    let country = $("<div />").appendTo(countryLine);
    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    let content = $("<span />")
        .attr("class", "calc_li_text_content")
        .text(regionNames.of(title))
        .appendTo(country);
  }

  function addNewListOfPaygItem(allData){
    // (we need to find all uls inside of templates)
    const allTemplates = document.querySelectorAll("template");
    const createUlArray = Array.from(allTemplates).reduce((acc, current) => {
      const currentElements = current.content.querySelectorAll(".custom__ul");
      return [...acc, ...Array.from(currentElements)];
    }, []);

    Array.prototype.map.call(createUlArray, (customUl) => {
      customUl.innerHTML = "";

      let restrictKey = 'allowed';
      if (customUl.getAttribute("data-type").includes('number')) {
        restrictKey = 'allow_dedicated';
      }

      const allDataWithoutResidenceCountry = omitKey(allData, countryCode);

      const { US, CA, GB, AU, D3, D2, ZZ, ...ommitedCountries } =
        allDataWithoutResidenceCountry;

      if (countryCode) {
        createCustomPaygLi(customUl, countryCode, allData, true);
      }
      if (countryCode !== "US") {
        createCustomPaygLi(customUl, "US", allData, false);
      }
      if (countryCode !== "CA") {
        createCustomPaygLi(customUl, "CA", allData, false);
      }
      if (countryCode !== "GB") {
        createCustomPaygLi(customUl, "GB", allData, false);
      }
      if (countryCode !== "AU") {
        createCustomPaygLi(customUl, "AU", allData, false);
      }
      for (let title in ommitedCountries) {
        if (ommitedCountries[title][restrictKey]) {
          createCustomPaygLi(customUl, title, ommitedCountries, false);
        }
      }
    });
  }

  function addDefaultListOfMonthlyItem(){
    let customUl = document.querySelector(".select-monthly-plans .custom__ul");
    customUl.innerHTML = "";

    if (countryCode) {
      createCustomMonthlyLi(customUl, countryCode, true);

      const elem = getElement(".select-monthly-plans");
      const selectHolder = getElement(".holder", elem);
      const selectHolderInput = getElement(".holder__input", elem);
      const currentSelected = getElement(".current", elem);
      if (currentSelected) {
        selectHolder.innerHTML = currentSelected.innerHTML;
        selectHolderInput.value = /select/i.test(selectHolder.textContent)
            ? ""
            : currentSelected.dataset.val;
      }
    }
  }

  function addNewListOfMonthlyItem(allMonthlyData) {
    let customUl = document.querySelector(".select-monthly-plans .custom__ul");
    customUl.innerHTML = "";

    let userCountry = countryCode;
    if (allMonthlyData[userCountry] === undefined) {
      userCountry = "US";
    }

    const allDataWithoutResidenceCountry = omitKey(allMonthlyData, userCountry);

    const { US, CA, GB, AU, D3, D2, ZZ, ...ommitedCountries } =
        allDataWithoutResidenceCountry;

    if (userCountry) {
      createCustomMonthlyLi(customUl, userCountry, true);
    }
    if (userCountry !== "US") {
      createCustomMonthlyLi(customUl, "US", false);
    }
    if (userCountry !== "CA") {
      createCustomMonthlyLi(customUl, "CA", false);
    }
    if (userCountry !== "GB") {
      createCustomMonthlyLi(customUl, "GB", false);
    }
    if (userCountry !== "AU") {
      createCustomMonthlyLi(customUl, "AU", false);
    }
    for (let title in ommitedCountries) {
      createCustomMonthlyLi(customUl, title, false);
    }

    const selectCountryOptions = getElements(".select-monthly-plans .select__options li");
    for (let k = 0; k < selectCountryOptions.length; ++k) {
      selectCountryOptions[k].addEventListener("click", () => {
        showMonthlyPlans(selectCountryOptions[k].dataset.val);
      });
    }
  }

  function omitKey(object, keyToOmit) {
    const { [keyToOmit]: omitted, ...rest } = object;
    return rest;
  }

  function getCookieDomain() {
    return (
      "." +
      location.hostname.split(".").reverse().splice(0, 2).reverse().join(".")
    );
  }

  function getPricingData() {
    $.ajax({
      dataType: "JSON",
      method: "GET",
      url: "https://rest.textmagic.com/pricing-info",
      success: function (xhr) {
        if (xhr.success) {
          for (const [key, value] of Object.entries(xhr.data)) {
            //if not allowed country set to US
            if(countryCode == key && value.allowed == false && value.allow_dedicated == false)
              countryCode = "US";  
          }    

          allData = xhr.data;
          dynamicPrices(allData);
          processPaygPricingData();
          addNewListOfPaygItem(allData);
          initSelects();
          initRangeSlider();
          initCalcSlider();
          initNumber();
          initTooltips();
          initNumberTable();
          initCalculator();
          addFirstLine();
          initTabs();
          const currency = allData?.[countryCode]?.default_currency;
          if (countryCode && currency) {
            updateCurrency(currency);
          }
          $(".preloader").remove(); 
          $(".calc-loading").remove(); 
        }
      },
    });
  }

  function updateCurrency(currency) {
    mainSelectedCurrency = currency;
    currentCurrency = currency;
    $("#custom-select").val(currency);
    $(".global-dynamic-currency").text(currencySymbols[mainSelectedCurrency]);
    $("template")
      .contents()
      .find(".global-dynamic-currency")
      .text(currencySymbols[mainSelectedCurrency]);

    const tableUls = document.querySelectorAll(".number-table-body ul");
    Array.from(tableUls).forEach((customUl) => {
      const tableLis = customUl.querySelectorAll("li");
      let selectedPrice = ""; // this price we will set inside of selected

      //get ul attributes
      const ulData = customUl.getAttribute("data-type").split(" ");
      //get ul data-type
      //create custom li
      Array.from(tableLis).forEach((customLi) => {
        let title = customLi.getAttribute("data-val").toUpperCase();
        if (!allData[title]) {
          title = "US";
        }
        if (ulData[1] === "lookup") {
          ulData[1] = "carrier_lookup";
          ulData[2] = "carrier_lookup";
        }
        const dataCountry = allData[title].prices[mainSelectedCurrency];
        if (Array.from(customLi.classList).includes("current")) {
          selectedPrice = dataCountry[ulData[1]].split(
            currencySymbols[mainSelectedCurrency]
          )?.[1];
        }
        customLi.setAttribute(
          "data-fixed-price-phone",
          dataCountry[ulData[2]].split(
            currencySymbols[mainSelectedCurrency]
          )?.[1]
        );

        customLi.setAttribute(
          "data-price",
          dataCountry[ulData[1]].split(
            currencySymbols[mainSelectedCurrency]
          )?.[1]
        );

        if (ulData[0] === 'SMS') {
          customLi.setAttribute(
              "data-price-receive",
              dataCountry['receive'].split(
                  currencySymbols[mainSelectedCurrency]
              )?.[1]
          );
          customLi.setAttribute(
              "data-price-ten-dlc",
              dataCountry['10dlc_registration'].split(
                  currencySymbols[mainSelectedCurrency]
              )?.[1]
          );
        }
      });

      let closestHolderInput =
        customUl.parentNode.parentNode.querySelector(".holder__input");
      updateCurrentPhoneData(
        customUl.closest(".phone_line"),
        closestHolderInput,
        true
      );
      deleteUsedCountries(customUl.closest(".phone_line"), closestHolderInput);
      setCalcLinesVars(customUl.closest("tr"));
    });
    dynamicPrices(allData);
    addNewListOfPaygItem(allData);
    calculatePrice();
  }

  function getNewPricingData() {
    addDefaultListOfMonthlyItem();
    $.ajax({
      dataType: "JSON",
      method: "GET",
      url: "https://rest.textmagic.com/new-pricing-info",
      success: function (xhr) {
        if (xhr.success) {
          allData = xhr.data["pay-as-you-go"];
          allMonthlyData = xhr.data["monthly-plans"];

          for (const [key, value] of Object.entries(allData)) {
            //if not allowed country set to US
            if(countryCode == key && value.allowed == false && value.allow_dedicated == false)
              countryCode = "US";
          }

          dynamicPrices(allData);
          processPaygPricingData();
          processMonthlyPricingData();
          procesByocPricingData();
          addNewListOfPaygItem(allData);
          addNewListOfMonthlyItem(allMonthlyData);
          initSelects();
          initRangeSlider();
          initCalcSlider();
          initNumber();
          initTooltips();
          initNumberTable();
          initCalculator();
          addFirstLine();
          const currency = allData?.[countryCode]?.default_currency;
          if (countryCode && currency) {
            updateCurrency(currency);
          }

          $(".preloader").remove();
          $(".calc-loading").remove();
        }
      },
    });
  }

  function processPaygPricingData() {
    if (
      allData.hasOwnProperty(countryCode) &&
      allData[countryCode].hasOwnProperty("allowed") &&
      allData[countryCode].allowed
    ) {
      selectedClass5 =
        selectedClass3 =
        selectedClass2 =
        selectedClass =
          countryCode;
    }

    currentCurrency = allData[selectedClass]["default_currency"];
    currentPrice = allData[selectedClass]["prices"][currentCurrency]["sms"];
    cost_per_month =
      allData[selectedClass]["prices"][currentCurrency]["inbound"];
    $(".right .cost-per-month").text(cost_per_month);
    $(".price .cost").html(currentPrice);
    $("#currency option." + currentCurrency).prop("selected", true);

    let country = $("#country");
    let country2 = $("#country2");
    let country3 = $("#country3");
    let country5 = $("#country5");

    $.each(allData, function (id, data) {
      if (data.hasOwnProperty("allowed") && !data.allowed) {
        country.find("option[class='" + id + "']").remove();
        country2.find("option[class='" + id + "']").remove();
        country3.find("option[class='" + id + "']").remove();
        $("table.calc .countrySelect")
          .find("option[class='" + id + "']")
          .remove();
      }
    });

    country.find("." + selectedClass).attr("selected", "selected");
    country.select2(options);
    country2.find("." + selectedClass2).attr("selected", "selected");
    country2.select2(options);
    country3.find("." + selectedClass3).attr("selected", "selected");
    country3.select2(options);
    $("#country4").select2(options);
    country5.find("." + selectedClass5).attr("selected", "selected");
    country5.select2(options);
    changeCurrency();
  }

  function processMonthlyPricingData() {
    let userCountry = countryCode;
    if (allMonthlyData[userCountry] === undefined) {
      userCountry = "US";
    }

    showMonthlyPlans(userCountry);
  }

  function procesByocPricingData() {
    let userCountry = countryCode;
    if (allMonthlyData[userCountry] === undefined) {
      userCountry = "US";
    }

    showByocPlans(userCountry);
  }

  function showMonthlyPlans(country) {
    let monthlyBlock = $(".monthly-block-sp"),
        i = 0,
        colours = ["grey", "green", "blue", "red", "purple"];

    Array.from(getElements(".monthly-block-sp .tile")).forEach((el) => {
      el.remove();
    });

    $.each(allMonthlyData[country.toUpperCase()], function (id, data) {
      monthlyBlock.append(
          monthly_billing_plan(
              id,
              data,
              colours[i] !== undefined ? colours[i] : "grey"
          )
      );
      i++;
    });
  }

  function showByocPlans(country) {
    let byocBlock = $(".byoc-block-sp"),
        i = 0,
        colours = ["grey", "green", "blue", "red", "purple"],
        limits = {99: '10,000', 199: '20,000', 499: '50,000', 999: '150,000', 1999: '300,000'};

    Array.from(getElements(".byoc-block-sp .tile")).forEach((el) => {
      el.remove();
    });

    $.each(allMonthlyData[country.toUpperCase()], function (id, data) {
      byocBlock.append(
          byoc_plan(
              id,
              data,
              limits[data.month_cost] !== undefined ? limits[data.month_cost] : "*",
              colours[i] !== undefined ? colours[i] : "grey"
          )
      );
      i++;
    });
  }

  function custom_template(obj) {
    let selectedClass = $(obj.element).attr("class");
    let data = $(obj.element).data();
    let text = $(obj.element).text();

    if (data && data["img_src"]) {
      let width = data["width"] ? data["width"] : 20;
      return $(
        "<div class='d-flex align-items-center country-select'><img src=\"" +
          data["img_src"] +
          '" style="width:' +
          width +
          "px;height:auto;margin-right:5px;border-radius:10px;opacity:0.7;\"/><span class='country-name'>" +
          text +
          "</span></div>"
      );
    } else if (selectedClass) {
      return $(
        '<span class="flag-24"><i class="' +
          selectedClass.toLowerCase() +
          '"></i> ' +
          text +
          "</span>"
      );
    }
  }

  function monthly_billing_plan(id, obj, color) {
    return (
      '<div class="tile tile--' + color + '">\n' +
      '    <div class="tile__title">' + obj.plan_name + '</div>\n' +
      '        <div class="tile__price-wrap">\n' +
      '            <div id="lite_cost" class="tile__price">' + obj.month_cost_formatted + '</div>\n' +
      '            <div class="tile__price-info"><span id="lite_currency">' + obj.plan_currency + '</span> per month</div>\n' +
      '        </div>\n' +
      '        <div class="tile__content">\n' +
      '        <ul class="tile__list">\n' +
      '            <li class="tile__list-position  tile__list-position--discount">\n' +
      '                <span id="lite_discount" class="discount-text">' + obj.message_profit + '</span> discount\n' +
      '                <div class="tooltip__container">\n' +
      '                    <div class="tooltip__icon">\n' +
      '                        <span class="toolitip__link-text"></span>\n' +
      '                        <span class="tmi-help"></span>\n' +
      '                    </div>\n' +
      '                    <div class="tooltip__base">\n' +
      '                        <div>\n' +
      '                            Compared to Textmagic pay-as-you-go price.\n' +
      '                        </div>\n' +
      '                    </div>\n' +
      '                </div>\n' +
      '            </li>\n' +
      '            <li class="tile__list-position tile__list-position--highlight">\n' +
      '                <span id="lite_month">' + obj.messages_per_month + ' texts / month</span>\n' +
      '                <div class="tooltip__container">\n' +
      '                    <div class="tooltip__icon">\n' +
      '                        <span class="toolitip__link-text"> </span>\n' +
      '                        <span class="tmi-help"></span>\n' +
      '                    </div>\n' +
      '                    <div class="tooltip__base">\n' +
      '                        <div>\n' +
      '                            Single messages are limited to 160 characters, including spaces. Longer messages incur <a target="_blank" href="https://support.textmagic.com/faq/maximum-length-of-a-text-message/">additional charges</a>.\n' +
      '                        </div>\n' +
      '                    </div>\n' +
      '                </div>\n' +
      '            </li>\n' +
      '            <li class="tile__list-position">\n' +
      '                <span id="lite_text">' + obj.message_price_formatted + ' per text</span>\n' +
      '                <div class="tooltip__container">\n' +
      '                    <div class="tooltip__icon">\n' +
      '                        <span class="toolitip__link-text"> </span>\n' +
      '                        <span class="tmi-help"></span>\n' +
      '                    </div>\n' +
      '                    <div class="tooltip__base">\n' +
      '                        <div>\n' +
      '                            This is the price per text that you will be paying for every message that goes over the plan limit.\n' +
      '                        </div>\n' +
      '                    </div>\n' +
      '                </div>\n' +
      '            </li>\n' +
      '            <li class="tile__list-position">All features included</li>\n' +
      '            <li class="tile__list-position">Chat AI assistant</li>\n' +
      '        </ul>\n' +
      '    </div>\n' +
      '    <div class="tile__button">\n' +
      '        <a href="https://app.textmagic.com/register" class="btn btn--small btn--orange">Start free trial</a>\n' +
      '    </div>\n' +
      '</div>'
    );
  }

  function byoc_plan(id, obj, limit, color) {
    return (
        '<div class="tile tile--' + color + '">\n' +
        '    <div class="tile__title">' + obj.plan_name + '</div>\n' +
        '    <div class="tile__price-wrap">\n' +
        '        <div class="tile__price">' + obj.month_cost_formatted + '</div>\n' +
        '        <div class="tile__price-info">' + obj.plan_currency + ' per month <br>+ CPaaS costs*</div>\n' +
        '    </div>\n' +
        '    <div class="tile__content">\n' +
        '        <ul class="tile__list">\n' +
        '            <li class="tile__list-position tile__list-position--highlight">\n' +
        '                ' + limit + ' texts / month\n' +
        '            </li>\n' +
        '            <li class="tile__list-position">\n' +
        '                Dispatched\n' +
        '                <div class="tooltip__container">\n' +
        '                    <div class="tooltip__icon">\n' +
        '                        <span class="toolitip__link-text"> via CPaaS</span>\n' +
        '                        <span class="tmi-help"></span>\n' +
        '                    </div>\n' +
        '                    <div class="tooltip__base">\n' +
        '                        <div>\n' +
        '                            Use the Textmagic user-friendly web app for easy messaging and teamwork, while CPaaS providers\' gateways handle the efficient dispatch and delivery of your messages.\n' +
        '                        </div>\n' +
        '                    </div>\n' +
        '                </div>\n' +
        '            </li>\n' +
        '            <li class="tile__list-position">\n' +
        '                All Textmagic features\n' +
        '            </li>\n' +
        '            <li class="tile__list-position">\n' +
        '                Chat AI assistant\n' +
        '            </li>\n' +
        '        </ul>\n' +
        '    </div>\n' +
        '    <div class="tile__button">\n' +
        '        <a href="https://app.textmagic.com/register" class="btn btn--small btn--orange">Start free trial</a>\n' +
        '    </div>\n' +
        '</div>'
    );
  }

  // create list for text-messages
  $("#country").on("select2:select", function (e) {
    selectedClass = e.params.data.element.className;
    currentPrice = allData[selectedClass]["prices"][currentCurrency]["sms"];
    let cost_per_month =
      allData[selectedClass]["prices"][currentCurrency]["inbound"];
    $("#text-messages.pricing-block .right .cost-per-month").text(
      cost_per_month
    );
    $("#text-messages.pricing-block .price .cost").html(currentPrice);
  });

  $("#currency.text-messages").change(function (e) {
    currentCurrency = $(this).val();
    currentPrice = allData[selectedClass]["prices"][currentCurrency]["sms"];
    let cost_per_month =
      allData[selectedClass]["prices"][currentCurrency]["inbound"];
    $("#text-messages.pricing-block .right .cost-per-month").text(
      cost_per_month
    );
    $("#text-messages.pricing-block .price .cost").html(currentPrice);
    $("#currency.numbers").val(currentCurrency);
    $("#currency.calls").val(currentCurrency);
    $("#currency.lookup").val(currentCurrency);
    $("#currency.mms").val(currentCurrency);
  });

  // create list for numbers
  $("#country2").on("select2:select", function (e) {
    selectedClass2 = e.params.data.element.className;
    currentPrice =
      allData[selectedClass2]["prices"][currentCurrency]["inbound"];
    $("#numbers.pricing-block .right .cost-per-month").text(currentPrice);
    $("#numbers.pricing-block .price .cost").html(currentPrice);
    if (selectedClass2 == "US" || selectedClass2 == "CA") {
      $("#numbers.pricing-block .afterForm .number-all").hide();
      $("#numbers.pricing-block .afterForm .number-north").show();
    } else {
      $("#numbers.pricing-block .afterForm .number-north").hide();
      $("#numbers.pricing-block .afterForm .number-all").show();
    }
  });

  $("#currency.numbers").change(function (e) {
    currentCurrency = $(this).val();
    currentPrice =
      allData[selectedClass2]["prices"][currentCurrency]["inbound"];
    $("#numbers.pricing-block .right .cost-per-month").text(currentPrice);
    $("#numbers.pricing-block .price .cost").html(currentPrice);
    $("#currency.text-messages").val(currentCurrency);
    $("#currency.calls").val(currentCurrency);
    $("#currency.lookup").val(currentCurrency);
    $("#currency.mms").val(currentCurrency);
  });

  // create list for calls
  $("#country3").on("select2:select", function (e) {
    selectedClass3 = e.params.data.element.className;
    currentPrice =
      allData[selectedClass3]["prices"][currentCurrency]["outbound_call"];
    let inbound_call =
      allData[selectedClass3]["prices"][currentCurrency]["inbound_call"];
    let cost_per_month =
      allData[selectedClass3]["prices"][currentCurrency]["inbound"];
    $("#calls.pricing-block .right .cost-per-month").text(cost_per_month);
    $("#calls.pricing-block .afterForm .outbound").text(currentPrice);
    $("#calls.pricing-block .afterForm .inbound").text(inbound_call);
    $("#calls.pricing-block .price .cost").html(currentPrice);
  });

  $("#currency.calls").change(function (e) {
    currentCurrency = $(this).val();
    currentPrice =
      allData[selectedClass3]["prices"][currentCurrency]["outbound_call"];
    let inbound_call =
      allData[selectedClass3]["prices"][currentCurrency]["inbound_call"];
    let cost_per_month =
      allData[selectedClass3]["prices"][currentCurrency]["inbound"];
    $("#calls.pricing-block .right .cost-per-month").text(cost_per_month);
    $("#calls.pricing-block .afterForm .outbound").text(currentPrice);
    $("#calls.pricing-block .afterForm .inbound").text(inbound_call);
    $("#calls.pricing-block .price .cost").html(currentPrice);
    $("#currency.text-messages").val(currentCurrency);
    $("#currency.numbers").val(currentCurrency);
    $("#currency.lookup").val(currentCurrency);
    $("#currency.mms").val(currentCurrency);
  });

  // create list for lookup
  $("#country4").on("select2:select", function (e) {
    selectedClass4 = e.params.data.element.className;
    currentPrice =
      allData[countryCode]["prices"][currentCurrency][selectedClass4];
    let cost_per_month =
      allData[countryCode]["prices"][currentCurrency]["inbound"];
    $("#lookup.pricing-block .right .cost-per-month").text(cost_per_month);
    $("#lookup.pricing-block .price .cost").html(currentPrice);
  });

  $("#currency.lookup").change(function (e) {
    currentCurrency = $(this).val();
    currentPrice =
      allData[countryCode]["prices"][currentCurrency][selectedClass4];
    let cost_per_month =
      allData[countryCode]["prices"][currentCurrency]["inbound"];
    $("#lookup.pricing-block .right .cost-per-month").text(cost_per_month);
    $("#lookup.pricing-block .price .cost").html(currentPrice);
    $("#currency.text-messages").val(currentCurrency);
    $("#currency.numbers").val(currentCurrency);
    $("#currency.calls").val(currentCurrency);
    $("#currency.mms").val(currentCurrency);
  });

  // create list for mms
  $("#country5").on("select2:select", function (e) {
    selectedClass5 = e.params.data.element.className;
    currentPrice = allData[selectedClass5]["prices"][currentCurrency]["mms"];
    let cost_per_month =
      allData[selectedClass5]["prices"][currentCurrency]["inbound"];
    $("#mms.pricing-block .right .cost-per-month").text(cost_per_month);
    $("#mms.pricing-block .afterForm .receive").text(currentPrice);
    $("#mms.pricing-block .price .cost").html(currentPrice);
  });

  $("#currency.mms").change(function (e) {
    currentCurrency = $(this).val();
    currentPrice = allData[selectedClass5]["prices"][currentCurrency]["mms"];
    let cost_per_month =
      allData[selectedClass5]["prices"][currentCurrency]["inbound"];
    $("#mms.pricing-block .right .cost-per-month").text(cost_per_month);
    $("#mms.pricing-block .afterForm .receive").text(currentPrice);
    $("#mms.pricing-block .price .cost").html(currentPrice);
    $("#currency.text-messages").val(currentCurrency);
    $("#currency.numbers").val(currentCurrency);
    $("#currency.calls").val(currentCurrency);
    $("#currency.lookup").val(currentCurrency);
  });

  function changeCurrency() {
    $.each(currencySymbols, function (index, value) {
      if (index == currentCurrency) {
        $(".bundle-currency").text(value);
      }
    });
  }

  /*modal price calculator*/
  // create list for modal window
  $(".countrySelect").select2(options);

  $(".countrySelect").on("select2:select", function (e) {
    selectedClass = e.params.data.element.className;
    currentPrice = allData[selectedClass]["prices"][currentCurrency]["sms"];
    $(this).parents("tr").find(".current-cost span").text(currentPrice);
    $(this)
      .parents(".country-wrapper")
      .find("select option")
      .removeAttr("selected");
    $(this)
      .parents(".country-wrapper")
      .find("select ." + selectedClass)
      .attr("selected", "selected");
    let cur_id = $(this).parents("tr").attr("id");
    let sms_count = $(this).parents("tr").find(".sms-count input").val();
    get_row_sum("#" + cur_id + ".row-1", sms_count);
  });

  $("body.page-template-pricing_template .pricing-block .pricing-link").click(
    function (e) {
      e.preventDefault();
      $(".calc-modal-wrap.fade").addClass("in");
      $("html").addClass("modal-open");
      let selectedValue = $("#text-messages #country option:selected").val();
      let cur_id = $("table.calc .row-1").attr("id");
      $("#" + cur_id + ".row-1")
        .find(".countrySelect")
        .val(selectedValue)
        .trigger("change");
      $("table.calc .row-1").each(function (index, value) {
        let id = $(this).attr("id");
        currentPrice =
          allData[$(this).find(".countrySelect option:selected").attr("class")][
            "prices"
          ][currentCurrency]["sms"];
        $("#" + id + ".row-1")
          .find(".current-cost span")
          .text(currentPrice);
        get_row_sum("#" + id + ".row-1");
      });
      get_total_sum();
    }
  );

  $(".calc-modal-wrap").click(function (e) {
    if ($(e.target).is(".calc-modal-wrap")) {
      close_modal();
    }
  });

  $(".pop-up-calc .close").click(() => close_modal());

  function close_modal() {
    $(".calc-modal-wrap").removeClass("in");
    $("html").removeClass("modal-open");
  }

  $(".row-1 .sms-count input").keyup(function () {
    let new_count = $(this).val();
    let cur_id = $(this).parents("tr").attr("id");
    get_row_sum("#" + cur_id + ".row-1", new_count);
  });

  function get_total_sum() {
    let total = 0;
    let curSymbol = currencySymbols[currentCurrency];
    $("table.calc .sms-sum span").each(function (index) {
      total += parseFloat($(this).attr("data-sum"));
    });
    total = total.toFixed(2);
    $("table.calc .total-amount").text(curSymbol + total);
  }

  function get_row_sum(row_class, count = 1000) {
    let curSymbol = currencySymbols[currentCurrency];
    let curCost = $(row_class + " .current-cost span")
      .text()
      .replace(/[^\d\.\-\ ]/g, "", "");
    $(row_class + " .sms-sum span")
      .text(curSymbol + parseFloat((curCost * count).toFixed(3)))
      .attr("data-sum", parseFloat((curCost * count).toFixed(3)));
    get_total_sum();
  }

  let divsCount = 1;
  let countrySequence = [
    "United States",
    "Canada",
    "United Kingdom",
    "Australia",
    "Switzerland",
    "Germany",
    "Ireland",
    "Finland",
    "Sweden",
  ];
  $("#add_country_btn").click(function (e) {
    $("table.calc .countrySelect").select2("destroy");
    let cloneRow = $("table.calc .row-1").first().clone(true);
    cloneRow.insertBefore("#total_row");
    cloneRow.attr("id", "row" + divsCount);

    let country = null;
    let tableLength = parseInt($("table.calc .row-1").length - 1);
    while (country == null) {
      let index = tableLength % countrySequence.length;
      if (
        $("table.calc .row-1 option[value='" + countrySequence[index] + "']")
          .length
      ) {
        country = countrySequence[index];
      }
      tableLength++;
    }

    cloneRow.find(".countrySelect").val(country);
    currentPrice =
      allData[cloneRow.find(".countrySelect option:selected").attr("class")][
        "prices"
      ][currentCurrency]["sms"];
    cloneRow.find(".current-cost span").text(currentPrice);
    let sms_count = cloneRow.find(".sms-count input").val();
    get_row_sum("#row" + divsCount + ".row-1", sms_count);
    $("table.calc .countrySelect").select2(options);
    divsCount++;
    get_total_sum();
  });

  $("#remove_row").click(function (e) {
    $("table.calc .countrySelect").select2("destroy");
    $(this).parents("tr.row-1").remove();
    $("table.calc .countrySelect").select2(options);
    get_total_sum();
  });

  $(".pricing-model-btn").click(function (e) {
    $(".pricing-model-container").hide();
    $("section.started").hide();
    $("#" + $(this).data("block")).show();
    $("#" + $(this).data("block") + "-started").show();
  });
  $(".pricing-model-block-wrap-tab").click(function (e) {
    $(".pricing-model-container").hide();
    $("section.started").hide();
    $("#" + $(this).data("block")).show();
    $("#" + $(this).data("block") + "-started").show();
  });

  $(document).on(
    "click",
    ".monthly-billing-block .monthly-billing-btn",
    function (e) {
      e.preventDefault();
      if (typeof Cookies === "function" && showMonthly) {
        Cookies.set("selectedPricing", $(this).data("pricing-plan"), {
          expires: 30,
          domain: getCookieDomain(),
        });
        location.href = "https://app.textmagic.com/register";
      }
    }
  );
  $(".pricing-block-wrap .trial").click(function (e) {
    if (typeof Cookies === "function" && showMonthly) {
      e.preventDefault();
      Cookies.set("selectedPricing", $(this).data("pricing-plan"), {
        expires: 30,
        domain: getCookieDomain(),
      });
      location.href = $(this).attr("href");
    }
  });
});

const createLiElement = (
  title,
  description,
  price,
  amount,
  tooltip,
  parent,
  min,
  max
) => {
  const insertTo = getElement(".calculator_results");
  const elWrapper = document.createElement("li");
  const elTitle = document.createElement("div");
  const elDescription = document.createElement("div");
  const hiddenHolder = getElement(".holder__input", parent);

  //   add ID to wrapper
  const randId = getRandomInt(100000000);
  parent.setAttribute("data-sidebar-id", randId);
  elWrapper.setAttribute("data-id", randId);
  if (ifItemExist(hiddenHolder)) hiddenHolder.setAttribute("data-id", randId);

  elWrapper.setAttribute("data-order", parent.getAttribute("data-order"));
  elWrapper.style.order = parent.getAttribute("data-order");

  //   title
  elTitle.classList.add("calc-right-subtitle");
  if (ifItemExist(tooltip) && tooltip != "") {
    tooltip = tooltip.replace("%br%", "<br>");
    elTitle.innerHTML =
      title +
      `<span class="tooltip"><span class="tooltip-link info"><span class="icon-help"></span> </span><span class="tooltip-content medium">${tooltip}</span></span>`;
  } else {
    elTitle.innerHTML = title;
  }

  elWrapper.appendChild(elTitle);

  // description tooltip -- add if needed
  // let tooltipContent = `
  //   <span class="tooltip">
  //       <span class="tooltip-link info">
  //           <span class="icon-help"></span>
  //       </span>
  //       <span class="tooltip-content medium">${tooltip}</span>
  //   </span>`;

  amount = parseInt(amount.replace(/,/g, ""));

  // Check if item has only fixed price per service not depends from amount
  let changedDescription = "";
  if (parent.getAttribute("data-fixed-price") !== "false") {
    let dataFixedPriceFormated = fits(
      parseFloat(parent.getAttribute("data-fixed-price")),
      10
    )
      ? parseFloat(parent.getAttribute("data-fixed-price"))
      : parseFloat(parent.getAttribute("data-fixed-price")).toFixed(1);
    changedDescription = description
      .replace(
        "%price%",
        currencySymbols[mainSelectedCurrency] + dataFixedPriceFormated
      )
      .replace(
        "%amount%",
        amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    elDescription.setAttribute(
      "phone-formated-price",
      parent.getAttribute("data-fixed-price")
    );
  } else {
    let formatedPrice = Number.isInteger(price * amount)
      ? price * amount
      : parseFloat(price * amount).toFixed(1);
    if (amount < parseInt(min)) amount = min;
    if (amount > parseInt(max)) amount = max;
    if (isNaN(amount)) amount = min;
    if (isNaN(formatedPrice)) formatedPrice = min * price;
    if (formatedPrice > price * max) formatedPrice = price * max;
    changedDescription = description
      .replace(
        "%price%",
        currencySymbols[mainSelectedCurrency] + numberWithCommas(formatedPrice)
      )
      .replace(
        "%amount%",
        amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    elDescription.setAttribute("phone-formated-price", price * amount);
  }
  elDescription.innerHTML = changedDescription;

  elWrapper.appendChild(elDescription);

  insertTo.appendChild(elWrapper);

  calculatePrice();
};

const deleteLiElement = (id, phoneSidebarId) => {
  let elem = getElement('li[data-id="' + id + '"]');
  let phoneElem = getElement('li[data-additional-id="' + phoneSidebarId + '"]');
  if (ifItemExist(elem)) {
    // elem.classList.add('hidden');
    elem.remove();
  }
  if (ifItemExist(phoneElem)) {
    // elem.classList.add('hidden');
    phoneElem.remove();
  }
};

const deletePhoneNumber = () => {
  // document.addEventListener("click", function (e) {
  //   if (e.target) {
  //     const classNames = ["row-delete-button"];
  //     if (
  //       classNames.some((className) => e.target.classList.contains(className))
  //     ) {
  //       e.stopPropagation();
  //     }
  //   }
  // });
};

const calculatePrice = () => {
  let totalPriceSelector = getElement("#total_price");
  let phoneFormatedPrice = getElements(
    ".calc-right-content [phone-formated-price]"
  );
  let arrayWithTotalPrice = [];
  if (ifItemExist(totalPriceSelector)) {
    if (ifItemExist(phoneFormatedPrice)) {
      Array.from(phoneFormatedPrice).forEach((item) => {
        let linePhonePrice = parseFloat(
          item.getAttribute("phone-formated-price").replace(/,/g, "")
        ).toFixed(2);
        if (!isNaN(parseFloat(linePhonePrice))) {
          arrayWithTotalPrice.push(parseFloat(linePhonePrice));
        }
      });
    }
    const totalPrice = arrayWithTotalPrice.reduce((accumulator, value) => {
      return accumulator + value;
    }, 0);
    if (parseFloat(totalPrice).toFixed(1) % 1 != 0) {
      let priceWithSmallDecimal = numberWithCommas(
        parseFloat(totalPrice).toFixed(2)
      ).split(".");
      totalPriceSelector.innerHTML =
        priceWithSmallDecimal[0] +
        `<span class="pricing-plans-price-cents">.${priceWithSmallDecimal[1]}</span>`;
    } else {
      let priceWithSmallDecimal = numberWithCommas(
        parseFloat(totalPrice).toFixed(2)
      );
      totalPriceSelector.textContent = priceWithSmallDecimal;
    }
  }
};

const calculatorFunctions = () => {
  const calCline = getElements(
    ".calc__line:not(.phone_line):not(.calc__line--placeholder)"
  );
  if (ifItemExist(calCline)) {
    Array.from(calCline).forEach((lineItem) => {
      let inputSelector = getElement(".calc__line-field", lineItem);
      let inputValue = 0;
      if ((inputSelector != null) & (inputSelector != undefined)) {
        inputValue = getElement(".calc__line-field", lineItem).value;
      }
      let rangeSlider = getElement(".range-slider", lineItem);
      let cost = lineItem.getAttribute("data-side-cost")
        ? lineItem.getAttribute("data-side-cost")
        : false;
      let min = lineItem.getAttribute("data-min-value")
        ? lineItem.getAttribute("data-min-value")
        : false;
      let max = lineItem.getAttribute("data-max-value")
        ? lineItem.getAttribute("data-max-value")
        : false;
      let title = lineItem.getAttribute("data-side-title")
        ? lineItem.getAttribute("data-side-title")
        : false;
      let description = lineItem.getAttribute("data-side-description")
        ? lineItem.getAttribute("data-side-description")
        : false;
      let tooltip = lineItem.getAttribute("data-side-tooltip");
      let addNewItemBtn = getElement(".add_service", lineItem);
      let deleteSidebarItem = getElement(".delete_sidebar_item", lineItem);

      if (
        lineItem.classList.contains("calc__line--opened") &&
        inputValue != 0
      ) {
        createLiElement(
          title,
          description,
          cost,
          inputValue,
          tooltip,
          lineItem,
          min,
          max
        );
      }

      //   Visible input
      addMultipleListeners(
        inputSelector,
        ["change"],
        () => {
          let dataSidebarId = lineItem.getAttribute("data-sidebar-id");
          let updatedInputValue = getElement(
            ".calc__line-field",
            lineItem
          ).value;
          let updatedCost = lineItem.getAttribute("data-side-cost")
            ? lineItem.getAttribute("data-side-cost")
            : false;
          lineItem.classList.add("active-in-sidebar");
          deleteLiElement(dataSidebarId);
          createLiElement(
            title,
            description,
            updatedCost,
            updatedInputValue,
            tooltip,
            lineItem,
            min,
            max
          );
          calculatePrice();
        },
        false
      );

      addMultipleListeners(
        rangeSlider,
        ["change", "input"],
        () => {
          let dataSidebarId = lineItem.getAttribute("data-sidebar-id");
          let updatedInputValue = getElement(
            ".calc__line-field",
            lineItem
          ).value;
          let updatedCost = lineItem.getAttribute("data-side-cost")
            ? lineItem.getAttribute("data-side-cost")
            : false;
          lineItem.classList.add("active-in-sidebar");
          deleteLiElement(dataSidebarId);
          createLiElement(
            title,
            description,
            updatedCost,
            updatedInputValue,
            tooltip,
            lineItem,
            min,
            max
          );
          calculatePrice();
        },
        false
      );

      // click on "add" button
      if (ifItemExist(addNewItemBtn)) {
        addMultipleListeners(
          addNewItemBtn,
          ["click"],
          () => {
            let dataSidebarId = lineItem.getAttribute("data-sidebar-id");
            let updatedInputValue = getElement(
              ".calc__line-field",
              lineItem
            ).value;
            let updatedCost = lineItem.getAttribute("data-side-cost")
              ? lineItem.getAttribute("data-side-cost")
              : false;
            lineItem.classList.add("active-in-sidebar");
            deleteLiElement(dataSidebarId);
            createLiElement(
              title,
              description,
              updatedCost,
              updatedInputValue,
              tooltip,
              lineItem,
              min,
              max
            );
            calculatePrice();
          },
          false
        );
      }

      // delete sidebar item (click on "cross" icon)
      if (ifItemExist(deleteSidebarItem)) {
        addMultipleListeners(
          deleteSidebarItem,
          ["click"],
          () => {
            let dataSidebarIdDefault = lineItem.getAttribute("data-sidebar-id");
            lineItem.classList.remove("active-in-sidebar");
            deleteLiElement(dataSidebarIdDefault);
            calculatePrice();
          },
          false
        );
      }
    });
  }
};

const createSidebarLiItem = (
  lineItem,
  lineDataAdditionalId,
  lineItemOrder,
  lineItemTitle,
  currentOptionPrice,
  formatedPrice,
  amount,
  currentOptionDescription,
  lineItemMin,
  lineItemMax,
  dataNewTrId,
  currentOptionValue,
  currentServiceName,
  lineTooltip
) => {
  let elToInsert = getElement(".calculator_results");
  let elWrapper = document.createElement("li");
  elWrapper.setAttribute("data-additional-id", lineDataAdditionalId);
  elWrapper.style.order = lineItemOrder;
  let elTitle = document.createElement("div");
  elTitle.classList.add("calc-right-subtitle");
  if (lineTooltip != "" && ifItemExist(lineTooltip)) {
    lineTooltip = lineTooltip.replace("%br%", "<br>");
    elTitle.innerHTML =
      lineItemTitle +
      `<span class="tooltip">
          <span class="tooltip-link info"><span class="icon-help"></span></span>
          <span class="tooltip-content medium">${lineTooltip} </span>
        </span>`;
  } else {
    elTitle.innerHTML = lineItemTitle;
  }
  if (amount < parseInt(lineItemMin)) amount = lineItemMin;
  if (amount > parseInt(lineItemMax)) amount = lineItemMax;
  if (isNaN(amount)) amount = lineItemMin;
  if (isNaN(formatedPrice)) formatedPrice = lineItemMin * currentOptionPrice;
  // if (formatedPrice > lineItemMax) formatedPrice = currentOptionPrice * lineItemMax;

  const valueInSidebar = removeTrailingZeros(
    parseFloat(numberWithCommas(formatedPrice)).toFixed(2)
  );
  const label = addPluralSuffix(currentServiceName, amount.toString());

  let elDescriptionContent = currentOptionDescription
    .replace("%price%", currencySymbols[mainSelectedCurrency] + valueInSidebar)
    .replace(
      "%amount%",
      amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    )
    .replace("%service_name%", label);
  lineItem.setAttribute("data-final-cost", currentOptionPrice * amount);
  let elDescriptionElement = document.createElement("div");
  if (
    currentOptionValue.toUpperCase() === "CARRIER" ||
    currentOptionValue.toUpperCase() === "EMAIL" ||
    currentOptionValue.toUpperCase() === "ALL"
  ) {
    elDescriptionElement.innerHTML = elDescriptionContent;
  } else {
    elDescriptionElement.innerHTML =
      elDescriptionContent +
      '<span class="light--text"> (' +
      currentOptionValue.toUpperCase() +
      ")</span>";
  }
  elDescriptionElement.setAttribute("data-new-tr-id", dataNewTrId);
  elDescriptionElement.setAttribute("phone-formated-price", formatedPrice);

  //creating new sidebar item
  elWrapper.appendChild(elTitle);
  elWrapper.appendChild(elDescriptionElement);
  // check if Item already exist in sidebar
  let ifItemExistInSidebar = getElement(
    'li[data-additional-id="' + lineDataAdditionalId + '"]'
  );
  if (!ifItemExist(ifItemExistInSidebar)) {
    elToInsert.appendChild(elWrapper);
  } else {
    let newEl = document.createElement("div");
    newEl.setAttribute("data-new-tr-id", dataNewTrId);
    newEl.setAttribute("phone-formated-price", formatedPrice);
    newEl.innerHTML =
      elDescriptionContent +
      '<span class="light--text"> (' +
      currentOptionValue.toUpperCase() +
      ")</span>";
    ifItemExistInSidebar.appendChild(newEl);
  }

  calculatePrice();
};

const createLiElementPhoneData = (lineItem) => {
  // varialbes
  let currentSelectOptions = getElements(
    ".select__options li.current",
    lineItem
  );
  let currentSelectOption =
    currentSelectOptions[currentSelectOptions.length - 1];

  // li.current
  let currentOptionDescription =
    currentSelectOption.getAttribute("data-sidebar");
  let currentServiceName =
    currentSelectOption.getAttribute("data-service-name");
  let currentOptionCountryValue = currentSelectOption.getAttribute("data-val");
  let currentOptionPrice = currentSelectOption.getAttribute("data-price");
  let dataNewTrId = currentSelectOption
    .closest("tr")
    .getAttribute("data-new-tr-id");
  let currentOptionValue = currentSelectOption.getAttribute("data-val");

  //lineItem
  let lineItemMin = lineItem.getAttribute("data-min-value");
  let lineItemMax = lineItem.getAttribute("data-max-value");
  let lineItemTitle = lineItem.getAttribute("data-side-title");
  let lineItemDescription = lineItem.getAttribute("data-side-description");
  let lineItemOrder = lineItem.getAttribute("data-order");
  let lineDataAdditionalId = lineItem.getAttribute("data-additional-id");
  let lineTooltip = lineItem.getAttribute("data-side-tooltip");

  //Price and amount
  let rangeSliderValue = getElement(
    ".range-slider",
    lineItem
  ).style.getPropertyValue("--value");
  let amount = parseInt(rangeSliderValue.replace(/,/g, ""));
  let formatedPrice = Number.isInteger(currentOptionPrice * amount)
    ? currentOptionPrice * amount
    : parseFloat(currentOptionPrice * amount).toFixed(1);

  // building Item for sidebar
  createSidebarLiItem(
    lineItem,
    lineDataAdditionalId,
    lineItemOrder,
    lineItemTitle,
    currentOptionPrice,
    formatedPrice,
    amount,
    currentOptionDescription,
    lineItemMin,
    lineItemMax,
    dataNewTrId,
    currentOptionValue,
    currentServiceName,
    lineTooltip
  );
};

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function onlyUniqueObj(value, index, self) {
  return self.indexOf(toUpperCase(value)) == toUpperCase(index);
}

const checkForCurrentLiValue = (lineItem) => {
  let current_li_array = getElements(".select__options li.current", lineItem);
  let array_used_values = [];
  if (ifItemExist(current_li_array)) {
    Array.from(current_li_array).forEach((current) => {
      array_used_values.push(current.getAttribute("data-val"));
    });
  }
  return array_used_values;
};
const deleteUsedCountries = (lineItem, changedInput, onlyCurrentLineItem) => {
  // delete used countries
  let allSelectOptions = getElements(".select__options li");
  if (onlyCurrentLineItem === true) {
    allSelectOptions = getElements(".select__options li", lineItem);
  }
  if (ifItemExist(allSelectOptions)) {
    Array.from(allSelectOptions).forEach((item) => {
      let itemDataVal = item.getAttribute("data-val");
      if (checkForCurrentLiValue(lineItem).includes(itemDataVal)) {
        item.classList.add("used");
        // holder
        let listHolder =
          changedInput.parentNode.parentNode.parentNode.querySelector(
            ".holder"
          );
        let newHolderContent =
          changedInput.parentNode.querySelector(".country-line").innerHTML;
        let wrapForCountryLine = document.createElement("div");
        wrapForCountryLine.classList.add("country-line");
        wrapForCountryLine.innerHTML = newHolderContent;
        listHolder.innerHTML = "";
        listHolder.appendChild(wrapForCountryLine);
      } else {
        item.classList.remove("used");
      }
    });
  }
};

const updateSidebarDivItem = (
  lineItem,
  lineDataAdditionalId,
  lineItemOrder,
  lineItemTitle,
  currentOptionPrice,
  formatedPrice,
  amount,
  currentOptionDescription,
  lineItemMin,
  lineItemMax,
  dataNewTrId,
  currentOptionCountryValue,
  currentServiceName
) => {
  if (amount < parseInt(lineItemMin)) amount = lineItemMin;
  if (amount > parseInt(lineItemMax)) amount = lineItemMax;
  if (isNaN(amount)) amount = lineItemMin;

  if (isNaN(formatedPrice))
    formatedPrice = lineItemMin * parseFloat(currentOptionPrice);
  if (
    parseFloat(formatedPrice) > lineItemMax * amount &&
    lineItemMax * amount > 1
  )
    formatedPrice = parseFloat(currentOptionPrice) * lineItemMax;
  if (ifItemExist(amount) && ifItemExist(lineItemMax)) {
    if (amount >= lineItemMax) formatedPrice = lineItemMax * currentOptionPrice;
  }

  const valueInSidebar = numberWithCommas(
    removeTrailingZeros(
      parseFloat(numberWithCommas(formatedPrice).replace(/,/g, "")).toFixed(2)
    )
  );
  const label = addPluralSuffix(currentServiceName, amount.toString());

  let elDescriptionContent = currentOptionDescription
    .replace("%price%", currencySymbols[mainSelectedCurrency] + valueInSidebar)
    .replace(
      "%amount%",
      amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    )
    .replace("%service_name%", label);
  lineItem.setAttribute("data-final-cost", currentOptionPrice * amount);

  let elDescriptionElement = document.createElement("div");
  elDescriptionElement.innerHTML = elDescriptionContent;
  elDescriptionElement.setAttribute("data-new-tr-id", dataNewTrId);
  elDescriptionElement.setAttribute("phone-formated-price", formatedPrice);

  // check if Item already exist in sidebar
  let parentDataAdditionalId = getElement(
    'li[data-additional-id="' + lineDataAdditionalId + '"]'
  );
  let parentDataNewTrId = getElement(
    'div[data-new-tr-id="' + dataNewTrId + '"]',
    parentDataAdditionalId
  );
  if (ifItemExist(parentDataNewTrId)) {
    parentDataNewTrId.setAttribute("phone-formated-price", formatedPrice);
    if (
      currentOptionCountryValue.toUpperCase() === "CARRIER" ||
      currentOptionCountryValue.toUpperCase() === "EMAIL" ||
      currentOptionCountryValue.toUpperCase() === "ALL"
    ) {
      parentDataNewTrId.innerHTML = elDescriptionContent;
    } else {
      parentDataNewTrId.innerHTML =
        elDescriptionContent +
        '<span class="light--text"> (' +
        currentOptionCountryValue.toUpperCase() +
        ")</span>";
    }
  }
  checkForCurrentLiValue();
  calculatePrice();
};

const updateCurrentPhoneData = (
  lineItem,
  currentHolderInput,
  updateCurrentNotLast
) => {
  // varialbes
  let currentSelectOptions = getElements(
    ".select__options li.current",
    lineItem
  );

  if (currentSelectOptions == undefined) {
    return;
  }

  let currentSelectOption =
    currentSelectOptions[currentSelectOptions.length - 1];
  if (ifItemExist(currentHolderInput)) {
    currentSelectOption =
      currentHolderInput.parentNode.parentNode.querySelector("li.current");
  }
  let dataNewTrId = currentSelectOption
    .closest("tr")
    .getAttribute("data-new-tr-id");

  // li.current
  let currentOptionDescription =
    currentSelectOption.getAttribute("data-sidebar");
  let currentOptionCountryValue = currentSelectOption.getAttribute("data-val");
  let currentOptionPrice = currentSelectOption.getAttribute("data-price");
  if (ifItemExist(currentHolderInput)) {
    currentOptionValue = currentHolderInput.value;
  }

  //lineItem
  let lineItemMin = lineItem.getAttribute("data-min-value");
  let lineItemMax = lineItem.getAttribute("data-max-value");
  let lineItemTitle = lineItem.getAttribute("data-side-title");
  let lineItemDescription = lineItem.getAttribute("data-side-description");
  let lineItemOrder = lineItem.getAttribute("data-order");
  let lineDataAdditionalId = lineItem.getAttribute("data-additional-id");
  let currentServiceName =
    currentSelectOption.getAttribute("data-service-name");

  //Price and amount
  let rangeSliderValue = getElement(
    ".range-slider",
    lineItem
  ).style.getPropertyValue("--value");
  let amount = parseInt(rangeSliderValue.replace(/,/g, ""));
  if (updateCurrentNotLast) {
    let calcLineField =
      currentHolderInput.parentNode.parentNode.parentNode.parentNode.querySelector(
        ".calc__line-field"
      );
    lineItemMin = calcLineField.getAttribute("min");
    lineItemMax =
      isNaN(parseInt(calcLineField.getAttribute("max").replace(/,/g, "")))
        ? calcLineField.getAttribute("max").replace(/,/g, "")
        : parseInt(calcLineField.getAttribute("max").replace(/,/g, ""));
  }
  let formatedPrice = Number.isInteger(currentOptionPrice * amount)
    ? currentOptionPrice * amount
    : (
          isNaN(parseFloat(currentOptionPrice * amount))
          ? 0
          :parseFloat(currentOptionPrice * amount).toFixed(1)
      );
  if (lineItem.classList.contains("active-in-sidebar")) {
    updateSidebarDivItem(
      lineItem,
      lineDataAdditionalId,
      lineItemOrder,
      lineItemTitle,
      currentOptionPrice,
      formatedPrice,
      amount,
      currentOptionDescription,
      lineItemMin,
      lineItemMax,
      dataNewTrId,
      currentOptionCountryValue,
      currentServiceName
    );
  }
};

const calculatorFunctionsPhoneLine = () => {
  const calCline = getElements(".phone_line");
  if (ifItemExist(calCline)) {
    Array.from(calCline).forEach((lineItem) => {
      let inputSelector = getElement(".calc__line-field", lineItem);
      let inputValue = 0;
      if ((inputSelector != null) & (inputSelector != undefined)) {
        inputValue = getElement(".calc__line-field", lineItem).value;
      }
      let rangeSlider = getElement(".range-slider", lineItem);
      let cost = lineItem.getAttribute("data-side-cost")
        ? lineItem.getAttribute("data-side-cost")
        : false;
      let title = lineItem.getAttribute("data-side-title")
        ? lineItem.getAttribute("data-side-title")
        : false;
      let description = lineItem.getAttribute("data-side-description")
        ? lineItem.getAttribute("data-side-description")
        : false;
      let tooltip = lineItem.getAttribute("data-side-tooltip");
      let addNewItemBtn = getElement(".add_service", lineItem);
      let addNewNumberBtn = getElement(".add_new_number", lineItem);
      let deleteSidebarItem = getElement(".delete_sidebar_item", lineItem);
      let holder__input = getElement(".holder__input", lineItem);
      let event = new Event("input", {
        bubbles: true,
        cancelable: true,
      });

      let eventClick = new Event("click", {
        bubbles: true,
        cancelable: true,
      });

      if (
        lineItem.classList.contains("calc__line--opened") &&
        inputValue != 0
      ) {
        createLiElement(
          title,
          description,
          cost,
          inputValue,
          tooltip,
          lineItem
        );
      }

      addMultipleListeners(
        rangeSlider,
        ["change", "input"],
        () => {
          let dataSidebarId = lineItem.getAttribute("data-sidebar-id");
          lineItem.classList.add("active-in-sidebar");
          updateCurrentPhoneData(lineItem);

          calculatePrice();
        },
        false
      );

      // click on "add" button
      if (ifItemExist(addNewItemBtn)) {
        addMultipleListeners(
          addNewItemBtn,
          ["click"],
          (e) => {
            let dataSidebarId = lineItem.getAttribute("data-sidebar-id");
            lineItem.classList.add("active-in-sidebar");
            let hiddenSidebarItemSlector = getElement(
              '.calc-right [data-id="' + dataSidebarId + '"]'
            );
            holder__input.dispatchEvent(event);
            if (ifItemExist(hiddenSidebarItemSlector)) {
              hiddenSidebarItemSlector.classList.remove("hidden");
            } else {
              createLiElementPhoneData(lineItem);
            }
            calculatePrice();
          },
          false
        );
      }

      // click on "add another country" button
      if (ifItemExist(addNewNumberBtn)) {
        addMultipleListeners(
          addNewNumberBtn,
          ["click"],
          (e) => {
            holder__input.dispatchEvent(eventClick);
            calculatePrice();
            createLiElementPhoneData(lineItem);
          },
          false
        );
      }

      // delete sidebar item (click on "cross" icon)
      if (ifItemExist(deleteSidebarItem)) {
        addMultipleListeners(
          deleteSidebarItem,
          ["click"],
          () => {
            let dataSidebarIdDefault = lineItem.getAttribute("data-sidebar-id");
            let dataSidebarIdPhone =
              lineItem.getAttribute("data-additional-id");
            lineItem.classList.remove("active-in-sidebar");
            deleteLiElement(dataSidebarIdDefault, dataSidebarIdPhone);
            calculatePrice();
          },
          false
        );
      }
    });
  }
};

document.addEventListener("input", function (e) {
  // Listen for change for holder__input when it's appended
  if (e.target && e.target.classList.contains("holder__input")) {
    updateCurrentPhoneData(e.target.closest(".phone_line"), e.target);
    deleteUsedCountries(e.target.closest(".phone_line"), e.target, true);
  }
});

document.addEventListener("click", function (e) {
  // Listen for change for holder__input when it's appended
  if (e.target && e.target.classList.contains("holder__input")) {
    deleteUsedCountries(e.target.closest(".phone_line"), e.target, true);

    let currentList = getElements(".select__options");
    if (ifItemExist(currentList)) {
      // let allUsedCurrentLi = getElements('li.current.used', currentList);
      Array.from(currentList).forEach((list) => {
        let allUsedCurrentLi = getElements("li.current.used", list);
        Array.from(allUsedCurrentLi).forEach((li, key) => {
          if (key != 0) {
            li.classList.remove("current", "used");
          }
        });
      });
    }
  }
});

const initCalculator = () => {
  calculatorFunctions();
  calculatorFunctionsPhoneLine();
  deletePhoneNumber();
  document.addEventListener("change", function (e) {
    // Listen for change for Visible input .calc__line-field
    if (e.target && e.target.classList.contains("calc__line-field")) {
      if (e.target.classList.contains("phone__calc__line-field")) {
        //   Visible input
        let inputSelector = e.target;
        let closestHolderInput =
          inputSelector.parentNode.parentNode.querySelector(".holder__input");
        updateCurrentPhoneData(
          inputSelector.closest(".phone_line"),
          closestHolderInput,
          true
        );
        deleteUsedCountries(
          inputSelector.closest(".phone_line"),
          closestHolderInput
        );
      }
      calculatePrice();
    }
  });
  const summaryTitle = getElement(".calc-right-title");
  summaryTitle.addEventListener('click', () => {
    if (summaryTitle.closest(".calc-right-usage").classList.contains('calc-right-usage--opened')) {
      summaryTitle.closest(".calc-right-usage").classList.remove('calc-right-usage--opened');
    } else {
      summaryTitle.closest(".calc-right-usage").classList.add('calc-right-usage--opened');
    }
  });
};

const pricingSearch = () => {
  let pricingInput = $(".pricing_search_input");
  if (pricingInput != null && pricingInput != undefined) {
    let modalContent = getElement(".modal-content");
    let collapsibleLines = getElement(".collapsible-lines", modalContent);
    let collapsibleLine = getElements(".collapsible-line", collapsibleLines);
    let collapsibleBlock = getElements(".collapsible-block", modalContent);
    let nothingToShow = getElement(".nothing-to-show");
    let SearchQuery = getElement(".search-query");
    pricingInput.on("keyup", (e) => {
      Array.from(collapsibleBlock).forEach((item, key) => {
        let collapsibleLabel = getElements(".collapsible-label", item);

        if (SearchQuery != undefined && SearchQuery != null) {
          SearchQuery.textContent = e.target.value;
        }

        // serach by table rows
        Array.from(collapsibleLabel).forEach((mainText) => {
          let collapsibleLabelSpanSelector = getElement(
            ".collapsible-label__span",
            mainText
          );
          let txtValue =
            collapsibleLabelSpanSelector.textContent ||
            collapsibleLabelSpanSelector.innerText;
          let prevTextContent = collapsibleLabelSpanSelector.textContent;
          if (
            txtValue
              .toUpperCase()
              .indexOf(pricingInput[0].value.toUpperCase()) > -1
          ) {
            mainText.parentNode.classList.remove("hidden");
            var regex = new RegExp(pricingInput[0].value, "gi"); // correct way
            let regexMatch =
              prevTextContent.match(regex) != null &&
              prevTextContent.match(regex)[0] != undefined &&
              prevTextContent.match(regex) != ""
                ? prevTextContent.match(regex)[0]
                : "";
            collapsibleLabelSpanSelector.innerHTML = prevTextContent.replace(
              regex,
              '<span class="highlight">' + regexMatch + "</span>"
            );
            // open collapsible-line if value exist in list
            mainText.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(
              "opened"
            );
          } else {
            mainText.parentNode.classList.add("hidden");
          }
        });

        let collasiblePositionCounter = getElements(
          ".collapsible-position",
          item
        ).length;
        let collapsiblePositionLength = getElements(
          ".collapsible-position.hidden",
          item
        ).length;

        if (collasiblePositionCounter == collapsiblePositionLength) {
          item.classList.add("hidden");
        } else {
          item.classList.remove("hidden");
        }

        Array.from(collapsibleLine).forEach((collLine) => {
          let collBlockLength = getElements(
            ".collapsible-block",
            collLine
          ).length;
          let collBlockHiddenLength = getElements(
            ".collapsible-block.hidden",
            collLine
          ).length;
          if (collBlockLength == collBlockHiddenLength) {
            collLine.classList.add("hidden");
          } else {
            collLine.classList.remove("hidden");
          }
        });

        let collapsibleLineTotal = getElements(
          ".collapsible-line",
          collapsibleLines
        ).length;
        let collapsibleLineHiddenTotal = getElements(
          ".collapsible-line.hidden",
          collapsibleLines
        ).length;
        if (collapsibleLineTotal == collapsibleLineHiddenTotal) {
          nothingToShow.classList.remove("hidden");
        } else {
          nothingToShow.classList.add("hidden");
        }
      });
    });
  }
};

// pricing search
const clearPricingSearch = () => {
  let searchWrapper = getElement(".search--collapsible");
  if (searchWrapper != null && searchWrapper != undefined) {
    let searchInput = getElement(".pricing_search_input", searchWrapper);
    let searchClear = getElement(".search__btn-close", searchWrapper);
    searchInput.addEventListener("keyup", (e) => {
      if (e.target.value.length > 1) {
        searchClear.style.display = "flex";
      } else {
        searchClear.style.display = "none";
      }
    });
    searchClear.addEventListener("click", (e) => {
      searchClear.style.display = "none";
      searchInput.value = "";
      nothingToShow = getElement(".nothing-to-show");

      nothingToShow.classList.add("hidden");
      let collapsibleLine = getElements(".collapsible-line");
      let highlightSelector = getElements(".highlight");
      if (ifItemExist(highlightSelector)) {
        Array.from(highlightSelector).forEach((item) => {
          item.classList.remove("highlight");
        });
      }
      Array.from(collapsibleLine).forEach((item) => {
        item.classList.remove("hidden");
        let getHidden = getElements(".hidden", item);
        Array.from(getHidden).forEach((hiddenItem) => {
          hiddenItem.classList.remove("hidden");
        });
      });
    });
  }
};

const initPopupAllFeatures = () => {
  const featuresTrigger = document.querySelectorAll(".calc-all-features .pricing-modal-button");
  const featuresModal = document.querySelector("#featuresModal");
  const featuresModalClose = document.querySelector(
    "#featuresModal .modal-close"
  );
  const featuresModalCloseBackdrop = document.querySelector(
    "#featuresModal .modal-backdrop"
  );

  const html = document.querySelector("html");
  if (!featuresTrigger || !featuresModalClose || !featuresModalCloseBackdrop)
    return;

  Array.from(featuresTrigger).forEach((el) => {
    el.addEventListener("click", () => {
      featuresModal.classList.add("shown");
      html.classList.add("hidden-xl");
    });
  });

  featuresModalClose.onclick = () => {
    featuresModal.classList.remove("shown");
    html.classList.remove("hidden-xl");
  };

  featuresModalCloseBackdrop.onclick = () => {
    featuresModal.classList.remove("shown");
    html.classList.remove("hidden-xl");
  };
};

ready(() => {
  pricingSearch();
  clearPricingSearch();
  initPopupAllFeatures();
});

function selectPaygTab() {
  $(".pay-as-you-go-cont").show();
  $(".monthly-plans-cont-tab").hide();
  $(".byoc-cont-tab").hide();
  $("#tab-1").attr("class", "tab-1 hero-tab-link hero-tab-link--active");
  $("#tab-2").attr("class", "tab-2 hero-tab-link");
  $("#tab-3").attr("class", "tab-3 hero-tab-link");
  $("#compare-pay-as-you-go").click();
  $("#faq-pay-as-you-go").click();
  $(".getting-started-byoc").hide();
}

function selectPlansTab() {
  $(".pay-as-you-go-cont").hide();
  $(".monthly-plans-cont-tab").show();
  $(".byoc-cont-tab").hide();
  $("#tab-1").attr("class", "tab-1 hero-tab-link");
  $("#tab-2").attr("class", "tab-2 hero-tab-link hero-tab-link--active");
  $("#tab-3").attr("class", "tab-3 hero-tab-link");
  $("#compare-monthly-plans").click()
  $("#faq-monthly-plans").click();
  $(".getting-started-byoc").hide();
}

function selectByocTab() {
  $(".pay-as-you-go-cont").hide();
  $(".monthly-plans-cont-tab").hide();
  $(".byoc-cont-tab").show();
  $("#tab-1").attr("class", "tab-1 hero-tab-link");
  $("#tab-2").attr("class", "tab-2 hero-tab-link");
  $("#tab-3").attr("class", "tab-3 hero-tab-link hero-tab-link--active");
  $("#compare-cpaas").click();
  $("#faq-cpaas").click();
  $(".getting-started-byoc").show();
}

jQuery(document).ready(function ($) {
  $('#tab-1').on("click", function(e) {
    e.preventDefault();
    selectPaygTab();
    window.history.pushState("object or string", "Title", "?payg");
  });

  $('#tab-2').on("click", function(e) {
    e.preventDefault();
    selectPlansTab();
    window.history.pushState("object or string", "Title", "?plans");
  });

  $('#tab-3').on("click", function(e) {
    e.preventDefault();
    selectByocTab();
    window.history.pushState("object or string", "Title", "?byoc");
  });

  let params = (new URL(document.location)).searchParams;
  if (params.has("byoc")) {
    selectByocTab();
  } else if (params.has("plans")) {
    selectPlansTab();
  }

  $("input[name=message-tabs]").bind( "click", function() {

    
    $("#collapsible-info__content_CPaaS").removeClass("hidden"); 

    let index = $(this).attr("data-id");
    if (index == 1) {
      $("#sep-1").addClass("sep-hide");

      $("#sep-2, #sep-3, #sep-4").removeClass("sep-hide"); 
    }

    if (index == 2) {
      $("#sep-1, #sep-2").addClass("sep-hide");
      $("#sep-3, #sep-4").removeClass("sep-hide"); 
    }
    if (index == 3) {
      $("#sep-2, #sep-3").addClass("sep-hide");
      $("#sep-1, #sep-4").removeClass("sep-hide");
    }

    if (index == 4) {
      $("#sep-3").addClass("sep-hide"); 
      $("#sep-1, #sep-2").removeClass("sep-hide"); 
      $("#sep-4").addClass("sep-hide"); 
    }

    if (index == 5) {
      $("#sep-1, #sep-2, #sep-3").removeClass("sep-hide");  
      $("#sep-4").addClass("sep-hide");  
    }    
  }); 

});


